/* eslint-disable camelcase */
import { getLocalizedStrings, getLocale } from '../misc';

import EN from '../../EN.json';
import FR from '../../FR.json';

const locale = getLocale();

const {
   contentfulValues: {
    officePhone: {
      opUtility
    },
   }
  
} = locale === 'en-US' ? EN : FR;
const {
  contentfulValues: {
    officePhone: {
      opBasic,
      op,
      opPlus,
      sixTwelveMonthPromo,
      sixTwelveMonthPromoBackpocket,
      standardMonthlyPricing,
      mtmPrice,
      yes,
      no,
      multiLine,
      ovLine,
      new: New,
      winback,
      unRegulated,
      tariffed
    },
    yearsTerm,
    fiveYearsTerm,
    monthly
  },
  quoteSummary: {
    products: {
      officeInternetCopper: valueOfficeInternetCopper,
      officeInternetFiber: valueOfficeInternetFiber,
      officePhone: valueOfficePhone,
      telusOptikTv: valueTelusOptikTv,
      secureBusiness: valueSecureBusiness,
      basicWifiAp: valueTwBasicWifiAp,
      telusBusinessWifi: valueTelusBusinessWifi
    }
  }
} = getLocalizedStrings();

export const CONSTANT = {
  KEYS: {
    USER_STATUS: {
      PENDING_APPROVAL: 'PENDING_APPROVAL',
      APPROVED: 'APPROVED'
    },
    ROLES: {
      ADMIN: 'ADMIN',
      SALES_REP: 'SALES_REP',
      SALES_MANAGER: 'SALES_MANAGER',
      TELUS_MANAGER: 'TELUS_MANAGER',
      SALES_SUPPORT: 'SALES_SUPPORT',
      ORDER_FULFILLMENT: 'ORDER_FULFILLMENT',
      PROPOSAL_HOUSE: 'PROPOSAL_HOUSE',
      TECH: 'TECH',
      ADT_RETENTION: 'ADT_RETENTION',
      CBM: 'CBM',
      EPP: 'EPP'
    },
    CHANNELS: {
      DEALER: 'DEALER',
      SBS: 'SBS',
      BSE_BSW: 'BSE_BSW',
      LSS: 'LSS',
      TAM: 'TAM',
      ADT_SALES: 'ADT_SALES',
      ADT: 'ADT',
      CSD: 'CSD',
      NBD: 'NBD',
      HEALTH: 'Health',
      TIP_SALES: 'TIP_SALES',
      BCX_CARE: 'BCX_CARE',
      SBS_TI_SALES: 'SBS_TI_SALES',
      CORP_STORE: 'CORP_STORE',
      HOME_SOLUTION: 'Home Solutions',
      FIELD_SALES_ONTARIO: 'FIELD_SALES_ONTARIO',
      TAG_BC: 'TAG BC',
      TAG_AB: 'TAG AB',
      ELITE_PROMOTIONS_AND_MARKETING_INC: 'Elite Promotions & Marketing Inc.',
      EVOLUTION_CLOUD_INC: 'EVOLUTION CLOUD INC',
      INSTINCTIVE_BUSINESS_TECHNOLOGY_INC:
        'Instinctive Business Technology Inc',
      TECH23_SOLUTIONS_INC: 'Tech23 Solutions Inc.',
      OUTPUT_INC: 'Output Inc.',
      '7X': '7X',
      NGM_NEW_GROWTH_MARKETS: 'NGM_NEW_GROWTH_MARKETS',
      NGM: 'NGM',
      SBS_TELESALES_TI: 'SBS_TELESALES_TI',
      SMB_TI_Sales_Digital: 'SMB TI Sales Digital',
      SMB_TI_Sales_Base_Management: 'SMB TI Sales Base Management',
      'SMB Growth Sales W 2A': 'SMB Growth Sales W 2A',
      'SMB Growth Sales W 2B': 'SMB Growth Sales W 2B',
      'SMB Growth Sales W 2C': 'SMB Growth Sales W 2C',
      'SMB Growth Sales W 2D': 'SMB Growth Sales W 2D',
      'SMB Growth Sales W 1A': 'SMB Growth Sales W 1A',
      'SMB Growth Sales W 1B': 'SMB Growth Sales W 1B',
      'SMB Growth Sales W 1C': 'SMB Growth Sales W 1C',
      'SMB Growth Sales W 1D': 'SMB Growth Sales W 1D',
      'SMB Growth Sales 30 to 100 2A': 'SMB Growth Sales 30 to 100 2A',
      'SMB Growth Sales 30 to 100 2B': 'SMB Growth Sales 30 to 100 2B',
      'SMB Growth Sales 30 to 100 2C': 'SMB Growth Sales 30 to 100 2C',
      'SMB Retention Sales 30 to 100 2D': 'SMB Retention Sales 30 to 100 2D',
      'SMB Growth Sales Advance WEST': 'SMB Growth Sales Advance WEST',
      'SMB New Growth Market 1': 'SMB New Growth Market 1',
      'SMB New Growth Market 2': 'SMB New Growth Market 2',
      'White Glove NBD Technicians': 'White Glove NBD Technicians',
      'SMB TI Sales Digital': 'SMB TI Sales Digital',
      'SMB TI Sales Base Management': 'SMB TI Sales Base Management',
      'SMB TI ADT Retention': 'SMB TI ADT Retention',
      'SMB TI Digital - EN': 'SMB TI Digital - EN',
      'SMB TI Digital - FR': 'SMB TI Digital - FR',
      'SMB TI HSIA Growth': 'SMB TI HSIA Growth',
      'SMB TI NBS Value Add': 'SMB TI NBS Value Add',
      'SMB TI WLN Retention': 'SMB TI WLN Retention',
      'SMB TI WLS Growth QC': 'SMB TI WLS Growth QC',
      'SMB TI WLS Growth ROC': 'SMB TI WLS Growth ROC',
      'SBS Telesales TI': 'SBS Telesales TI',
      'SMB L&R 2': 'SMB L&R 2',
      'SMB L&R 3': 'SMB L&R 3',
      'SMB L&R 4': 'SMB L&R 4',
      'SMB L&R 5': 'SMB L&R 5',
      'SMB L&R TI': 'SMB L&R TI',
      'SMB L&R TI 2': 'SMB L&R TI 2',
      'SMB L&R TI 3': 'SMB L&R TI 3',
      'TM Test Ind Dlr': 'TM Test Ind Dlr',
      'SMB Growth Sales CBS': 'SMB Growth Sales CBS',
      'SMB TI Growth National': 'SMB TI Growth National',
      'SMB RFS 1': 'SMB RFS 1',
      'SMB RFS 2': 'SMB RFS 2',
      'AllianceIT' : 'AllianceIT'
    },
    OutletId: {
      '0000029594': '0000029594',
      '0000029610': '0000029610',
      '0000029654': '0000029654',
      '0000423002': '0000423002',
      '0000426001': '0000426001',
      '0000602001': '0000602001',
      '0000602003': '0000602003',
      '0000602007': '0000602007',
      '0000602008': '0000602008',
      '0000602010': '0000602010',
      '0000606002': '0000606002',
      '0000614007': '0000614007',
      '0000625002': '0000625002',
      '0000625004': '0000625004',
      '0000625005': '0000625005',
      '0000625008': '0000625008',
      '0000633005': '0000633005',
      '0000692003': '0000692003',
      '0000693006': '0000693006',
      '1100000008': '1100000008',
      '1100000541': '1100000541',
      '1100000629': '1100000629',
      '1100025680': '1100025680',
      '1100025681': '1100025681',
      '1100026300': '1100026300',
      '1100032061': '1100032061',
      '1100034223': '1100034223',
      '1100034406': '1100034406',
      '1100037897': '1100037897',
      '1100040659': '1100040659',
      '1100040861': '1100040861',
      '1100041423': '1100041423',
      '1100043777': '1100043777',
      '1100046099': '1100046099',
      '1100047437': '1100047437',
      '1100047705': '1100047705',
      '1100048577': '1100048577',
      '1100048613': '1100048613',
      '1100048749': '1100048749',
      '1100048751': '1100048751',
      '1100048752': '1100048752',
      '1100048753': '1100048753',
      '1100048773': '1100048773',
      '1100049115': '1100049115',
      '1100049641': '1100049641',
      '1100049696': '1100049696',
      '1100049698': '1100049698',
      '1100050486': '1100050486',
      '1100050554': '1100050554',
      '1100050555': '1100050555',
      '1100050840': '1100050840',
      '1100052292': '1100052292',
      '1100053681': '1100053681',
      '1100053710': '1100053710',
      '1100053711': '1100053711',
      '1100053712': '1100053712',
      '1100053735': '1100053735',
      '1100053736': '1100053736',
      '1100053737': '1100053737',
      '1100053738': '1100053738',
      '1100053739': '1100053739',
      B001000001: 'B001000001',
      B00AB00431: 'B00AB00431',
      B00AB00478: 'B00AB00478',
      B00AB00479: 'B00AB00479',
      B00AB00482: 'B00AB00482',
      B00AB00500: 'B00AB00500',
      B00AB00615: 'B00AB00615',
      B00AB00834: 'B00AB00834',
      B00AB00970: 'B00AB00970',
      '1100054384': '1100054384',
      '1100054405': '1100054405',
      '9900000021': '9900000021'
    }
  },
  ROLES: {
    ADMIN: 0,
    SALES_REP: 0,
    SOV_AGENT: 0,
    SRT_GROUP: 0,
    SOV_ADMIN: 0,
    PRODUCT_TEAM: 0
  },
  CHANNELS: {
    DEALER_ADT: 0,
    CORP_STORE: 0,
    SBS: 0,
    BSE_BSW: 0,
    LSS: 0,
    TAM: 0,
    ADT_SALES: 0,
    TIP_SALES: 0,
    DEALER: 0
  }
};

export const PERMISSIONS = {
  ADMIN: {
    'wireline and secure business': true,
    referrals: true,
    wireless: true,
    'TELUS Business Connect Quote Tool/Order Form': true,
    'Phone Number Portal Tool': true,
    'My Order Dashboard': true,
    'brp webform': true,
    'TELUS Business Connect Contact Centre & Professional Services': true,
    channels: {
      name: 'Home Solutions'
    },
    'TELUS Business Apps': true,
    'TELUS IOT': true,
    'fully managed': true,
    vulcan: true,
    'fully managed SOW': true,
    cybersecurity: true,
    OCDR: true
  },
  SOV_AGENT: {
    'wireline and secure business': true,
    referrals: false,
    wireless: true,
    'TELUS Business Connect Quote Tool/Order Form': true,
    'Phone Number Portal Tool': true,
    'My Order Dashboard': true,
    'fully managed': true,
    vulcan: true,
    'fully managed SOW': true,
    cybersecurity: true,
    OCDR: true,
    channels: {
      name: 'Home Solutions'
    }
  },
  SOV_ADMIN: {
    'wireline and secure business': true,
    referrals: false,
    wireless: true,
    'TELUS Business Connect Quote Tool/Order Form': true,
    'My Order Dashboard': true,
    'Phone Number Portal Tool': true,
    vulcan: true,
    'fully managed SOW': true,
    cybersecurity: true,
    OCDR: true,
    channels: {
      name: 'Home Solutions'
    }
  },
  SRT_GROUP: {
    'wireline and secure business': true,
    referrals: false,
    wireless: true,
    'TELUS Business Connect Quote Tool/Order Form': true,
    'Phone Number Portal Tool': true,
    'My Order Dashboard': true,
    vulcan: true,
    'fully managed SOW': true,
    cybersecurity: true,
    OCDR: true,
    channels: {
      name: 'Home Solutions'
    }
  },
  PRODUCT_TEAM: {
    'wireline and secure business': true,
    referrals: false,
    wireless: true,
    'TELUS Business Connect Quote Tool/Order Form': true,
    'Phone Number Portal Tool': true,
    'My Order Dashboard': true,
    vulcan: true,
    'fully managed SOW': true,
    cybersecurity: true,
    OCDR: true,
    channels: {
      name: 'Home Solutions'
    }
  },
  SALES_REP: {
    'wireline and secure business': true,
    referrals: true,
    wireless: true,
    'TELUS Business Connect Quote Tool/Order Form': true,
    'Phone Number Portal Tool': true,
    'My Order Dashboard': true,
    'brp webform': true,
    'TELUS Business Connect Contact Centre & Professional Services': true,
    vulcan: true,
    'fully managed SOW': true,
    OCDR: true,
    channels: {
      name: 'Home Solutions'
    },
    'TELUS Business Apps': true,
    'TELUS IOT': true,
    'fully managed': true,
    cybersecurity: true
  },
  ORDER_FULFILLMENT: {
    'wireline and secure business': true,
    referrals: true,
    wireless: false,
    'TELUS Business Connect Quote Tool/Order Form': true,
    'Phone Number Portal Tool': true,
    'My Order Dashboard': true,
    'brp webform': false,
    'TELUS Business Connect Contact Centre & Professional Services': false,
    OCDR: true,
    vulcan: true,
    channels: {
      name: 'Home Solutions'
    },
    'TELUS IOT': true,
    'fully managed': true,
    'fully managed SOW': true,
    cybersecurity: true
  },
  PROPOSAL_HOUSE: {
    'wireline and secure business': false,
    referrals: true,
    wireless: false,
    'TELUS Business Connect Quote Tool/Order Form': true,
    'Phone Number Portal Tool': true,
    'My Order Dashboard': false,
    'brp webform': false,
    'TELUS Business Connect Contact Centre & Professional Services': false,
    'fully managed': true,
    channels: {
      name: 'Home Solutions'
    }
  },
  TELUS_MANAGER: {
    'wireline and secure business': true,
    referrals: false,
    wireless: true,
    'TELUS Business Connect Quote Tool/Order Form': true,
    'Phone Number Portal Tool': true,
    'My Order Dashboard': true,
    channels: {
      name: 'Home Solutions'
    }
  },
  SALES_MANAGER: {
    'wireline and secure business': true,
    referrals: true,
    wireless: true,
    'TELUS Business Connect Quote Tool/Order Form': true,
    'Phone Number Portal Tool': true,
    'My Order Dashboard': true,
    'brp webform': true,
    'TELUS Business Connect Contact Centre & Professional Services': true,
    OCDR: true,
    vulcan: true,
    channels: {
      name: 'Home Solutions'
    },
    'TELUS Business Apps': true,
    'TELUS IOT': true,
    'fully managed': true,
    'fully managed SOW': true,
    cybersecurity: true
  },
  SALES_SUPPORT: {
    'wireline and secure business': true,
    referrals: true,
    wireless: true,
    'TELUS Business Connect Quote Tool/Order Form': true,
    'TELUS Business Connect Contact Centre & Professional Services': true,
    'Phone Number Portal Tool': true,
    'My Order Dashboard': true,
    'brp webform': false,
    OCDR: true,
    vulcan: true,
    channels: {
      name: 'Home Solutions'
    },
    'TELUS Business Apps': true,
    'TELUS IOT': true,
    'fully managed': true,
    cybersecurity: true
  },
  TECH: {
    'wireline and secure business': false,
    referrals: true,
    wireless: true,
    'TELUS Business Connect Quote Tool/Order Form': true,
    'Phone Number Portal Tool': true,
    'My Order Dashboard': true,
    channels: {
      name: 'Home Solutions'
    }
  },
  CBM: {
    'wireline and secure business': false,
    referrals: true,
    wireless: true,
    'TELUS Business Connect Quote Tool/Order Form': true,
    'Phone Number Portal Tool': true,
    'My Order Dashboard': true,
    channels: {
      name: 'Home Solutions'
    }
  },
  EPP: {
    'wireline and secure business': false,
    referrals: true,
    wireless: true,
    'TELUS Business Connect Quote Tool/Order Form': true,
    'Phone Number Portal Tool': true,
    'My Order Dashboard': true,
    channels: {
      name: 'Home Solutions'
    }
  },
  ADT_RETENTION: {
    'wireline and secure business': false,
    referrals: true,
    wireless: true,
    'TELUS Business Connect Quote Tool/Order Form': true,
    'Phone Number Portal Tool': true,
    'My Order Dashboard': true,
    channels: {
      name: 'Home Solutions'
    }
  }
};

export const RECAPTCHA_SITE_KEY = '6LeDZq4ZAAAAAPrApKRb5v9UFb7_nd09kiY_S8hJ';

export const ROLES = ['SALES_REP', 'SALES_MANAGER', 'TELUS_MANAGER'];

export const registrationRoles = [
  {
    text: 'Sales Rep',
    value: 'SALES_REP'
  },
  {
    text: 'Sales Manager',
    value: 'SALES_MANAGER'
  },
  {
    text: 'TELUS Manager',
    value: 'TELUS_MANAGER'
  }
];
export const sourceOfChannelsList = [
  'ISS_ONTARIO',
  'ISS_BRITISH_COLUMBIA',
  'ISS_ALBERTA',
  'INKEROS_WEST',
  'INKEROS_EAST'
];
export const channels = [
  {
    text: 'SBS ISS QC/ATL',
    value: 'SBS_ISS_QC_ATL'
  },
  {
    text: 'TRL BCX',
    value: 'TRL_BCX'
  },
  {
    text: 'BCX Care',
    value: 'BCX_CARE'
  },
  {
    text: 'BCX - LOYALTY',
    value: 'BCX_LOYALTY'
  },
  {
    text: 'SBS TI Sales',
    value: 'SBS_TI_SALES'
  },
  {
    text: 'ISS Ontario',
    value: 'ISS_ONTARIO'
  },
  {
    text: 'ISS British Columbia',
    value: 'ISS_BRITISH_COLUMBIA'
  },
  {
    text: 'ISS Alberta',
    value: 'ISS_ALBERTA'
  },
  {
    text: 'NGM - New Growth Markets',
    value: 'NGM - New Growth Markets'
  },

  {
    text: 'NGM',
    value: 'NGM'
  },
  {
    text: 'SBS Direct Sales AB',
    value: 'SBS_DIRECT_SALES_AB'
  },
  {
    text: 'SBS Direct Sales BC',
    value: 'SBS_DIRECT_SALES_BC'
  },
  {
    text: 'SBS Direct Sales East',
    value: 'SBS_DIRECT_SALES_EAST'
  },
  {
    text: 'Inkeros West',
    value: 'INKEROS_WEST'
  },
  {
    text: 'Inkeros East',
    value: 'INKEROS_EAST'
  },
  {
    text: 'TELUS Mid Market Quebec',
    value: 'TELUS_MID_MARKET_QUEBEC'
  },
  {
    text: 'TELUS MidMarket',
    value: 'TELUS_MID_MARKET'
  },
  {
    text: 'Dealer',
    value: 'DEALER'
  },
  {
    text: 'LTS TBS',
    value: 'LTS_TBS'
  },
  {
    text: 'Corp Store',
    value: 'CORP_STORE'
  },
  {
    text: 'TELUS Internal Field Sales',
    value: 'TELUS_INTERNAL_FIELD_SALES'
  },
  {
    text: 'Go Sales',
    value: 'GO_SALES'
  },
  {
    text: 'Connect 6',
    value: 'CONNECT_6'
  },
  {
    text: 'Field Sales Ontario',
    value: 'FIELD_SALES_ONTARIO'
  },
  {
    text: 'SMB Indirect Sales',
    value: 'SMB_INDIRECT_SALES'
  }
];

export const salesRepChannels = [
  {
    text: 'Home Solutions',
    value: 'Home Solutions'
  }
];
export const referalChannels = [
  {
    text: 'CSD',
    value: 'CSD'
  },
  {
    text: 'NBD',
    value: 'NBD'
  },
  {
    text: 'ADT',
    value: 'ADT'
  }
];

export const channelsList = [
  { text: 'SBS', value: 'SBS' },
  { text: 'BSE/BSW', value: 'BSE_BSW' },
  { text: 'LSS', value: 'LSS' },
  { text: 'TAM', value: 'TAM' },
  { text: 'ADT Sales', value: 'ADT_SALES' },
  { text: 'TIP Sales', value: 'TIP_SALES' },
  { text: 'Dealer', value: 'DEALER' }
];
export const complexChannels = [
  'LTS_TBS',
  'DEALER',
  'INKEROS_EAST',
  'INKEROS_WEST'
];
export const QuoteSummaryFr = 'Écran de sommaire de la commande';
export const QuoteSummaryEn = 'Quote Summary';
export const hardWareCredit = 'Hardware Credit (Up to $200)';
export const zeroInstallationFee = '$0 installation fee';
export const threeMonthFeeValue = '3 Months Free - 90 Day Trial';
export const $199offInstallation = '$199 off installation';
export const $100offInstallation = '$100 off installation';
export const maxUploadSizeValue = 9000000;
export const maxUploadSizeValueWLS = 10000000;
export const keyFileSizeExceeded = 'fileSizeExceeded';
export const keyDirectorApprovalRequired = 'directorApprovalRequired';
export const fieldFrenchSecureBusiness = 'Sécurité d’entreprise';
export const fieldForbearance = 'forbearance';
export const fieldWhatSubjectWouldYouLikeToDisplayOnTheQuote =
  'whatSubjectWouldYouLikeToDisplayOnTheQuote';
export const maxUploadSizeErrorMessage =
  'Maximum size allowed for files collectively is 8-9MB';
export const maxUploadSizeErrorMessageWLS =
  'Maximum size allowed for files collectively is 9 -10 MB';
export const minimum16SubscribersErrorMessage =
  'Number of subscribers must be 16 or more';
// Below error will be shown if director approval field is selected and no document is attached
export const directorApprovalDocRequired =
  'Please attach director approval document';
export const minimum16SubscribersErrorMessageDefault = 'Min value is 16';
export const wirelessAdditionalDocumentsOne = 'wirelessAdditionalDocumentsOne';
export const wirelessAdditionalDocumentsTwo = 'wirelessAdditionalDocumentsTwo';
export const wirelessAdditionalDocumentsComments =
  'wirelessAdditionalDocumentsComments';
export const fieldWirelinePreferedInstallDate = 'wirelinePreferedInstallDate';
export const fieldWirelineSecondaryInstallDate = 'wirelineSecondaryInstallDate';
export const fieldWirelinePreferedInstallDateVulcan =
  'wirelinePreferedInstallDateVulcan';
export const fieldSecondaryInstallDateVulcan = 'secondaryInstallDateVulcan';
export const fieldRCID = 'rCID';
export const fieldRCIDOptik = 'rCIDOptik';
export const description = 'description';
export const errorInMSS = ' errorInMSS';
export const mssDefects = 'MSS Defect';
export const mssIssue = 'MSS Issue';
export const smbSales = 'SMB Sales';

export const fieldCustomerAccountName = 'customerAccountName';
export const fieldCustomerProfileID = 'customerProfileID';
export const fieldCallToBookIt = 'CallToBookIt';
export const fieldTsbPreferedInstallDate = 'tsbPreferedInstallDate';
export const fieldTsbSecondaryPreferredInstallDate =
  'tsbSecondaryPreferredInstallDate';
export const fieldTsbTertiaryPreferredInstallDate = 'tsbTertiaryInstallDate';
export const fieldCustomersHoursOfAvailability = 'customerHoursOfAvailability';
export const tsbInstallDateFields = [
  fieldTsbPreferedInstallDate,
  fieldTsbSecondaryPreferredInstallDate,
  fieldTsbTertiaryPreferredInstallDate
];
export const wireLineDateFields = [
  ...tsbInstallDateFields,
  fieldWirelinePreferedInstallDate,
  fieldWirelineSecondaryInstallDate
];
export const canadianNationalHolidays = [
  '01-01',
  '02-04',
  '05-04',
  '09-05',
  '24-05',
  '20-06',
  '24-06',
  '01-07',
  '06-09',
  '11-10',
  '12-25',
  '12-31'
];
export const canadianNonQCHolidays = [
  '01-01',
  '02-04',
  '05-04',
  '24-05',
  '01-07',
  '02-08',
  '06-09',
  '11-10',
  '11-14',
  '25-12',
  '26-12'
];

export const fieldPrefieldPreferredArrivalWindow =
  'prefieldPreferredArrivalWindow';
export const fieldInstallationPreferredArrivalWindow =
  'installationPreferredArrivalWindow';
export const inputTypeFile = 'File';
export const sixMonthsFree = '6monthFree';
export const twoMonthsDuration = 'twoMonthsDuration';
export const threeMonthsFree = 'threeMonthsFree';
export const twoMonthsFreeFibre = 'twoMonthsFreeFibre';
export const existingWireless = '$10 Bundle Discount';
export const existingWireline =
  '$20 off with two new or existing Wireline/Wireless';

export const fieldsToHideforNonOptikAndPhoneChannels = [
  fieldCallToBookIt,
  fieldWirelineSecondaryInstallDate,
  fieldCustomersHoursOfAvailability,
  fieldInstallationPreferredArrivalWindow,
  fieldTsbSecondaryPreferredInstallDate,
  fieldTsbTertiaryPreferredInstallDate
];

export const fieldsToShowforNonOptikAndPhoneChannels = [
  fieldRCID,
  fieldCustomerAccountName
];
export const fieldsToShowforOptikTV = [fieldRCIDOptik, fieldCustomerProfileID];

export const nameTelusTVForBusiness = 'TELUS TV for Business';

export const landingPageForm = 'Landing_Page';
export const wirelessLandingPageForm = 'Wireless_Landing_Page';
export const wirelessOrderForm = 'Wireless_Online_Form';
export const fullyManagedForm = 'Fully_Managed_Form';
export const cybersecurityForm = 'Cybersecurity_Form'
export const vulcanForm = 'Vulcan_Form';
export const vulcanLandingPage = 'Vulcan_Landing_Page';
export const fullyManagedSOWForm = 'Fully_Managed_SOW_Form';
export const ocdrForm = 'OCDR_Form';
export const fullyManagedLandingPage = 'Fully_Managed_Landing_Page';
export const cybersecurityLandingPage = 'Cybersecurity_Landing_Page'
export const ocdrLandingPage = 'OCDR_Landing_Page';
export const fullyManagedSOWLandingPage = 'Fully_Managed_SOW_Landing_Page';
export const fullyManagedSOWFormStep = 'Fully Managed SOW Landing Page';
export const quoteToolForm = 'Quote_tool';
export const wirelineAndSecureBusinessForm = 'wireline_and_secure_business';
export const orderDetailsForm = 'Order_Details';
export const orderSummaryForm = 'Order_Summary';
export const fieldKeyOfficePhone = 'Office Phone';
export const fieldKeyTelusOpticTv = 'TELUS TV for Business';
export const categoryWireless = 'wireless';
export const categoryBrp = 'brp_webform';
export const categoryWireline = 'wireline_and_secure_business';
export const categoryFullyManaged = 'fully_managed';
export const categoryCybersecurity = 'cybersecurity'
export const categoryVulcan = 'vulcan';
export const categoryFullyManagedSOW = 'fully_managed_SOW';
export const categoryOCDR = 'OCDR';
export const brpPrequalification = 'BRP_Prequalification';
export const brpOrderForm = 'BRP_online_form';
export const orderStatus = {
  incomplete: 'INCOMPLETE',
  pendingValidation: 'PENDING_VALIDATION',
  validated: 'ORDER_VALIDATED',
  revisionRequired: 'REVISION_REQUIRED',
  waitingOnCredit: 'WAITING_ON_CREDIT',
  newOrder: 'NEW_ORDER',
  submitted: 'SUBMITTED',
  canceled: 'ORDER_CANCELED',
  waitingOnSales: 'WAITING_ON_SALES',
  canceledBySalesRep: 'CANCELED_BY_SALESREP',
  completed: 'COMPLETED',
  responded: 'RESPONDED',
  contractSigned: 'CONTRACT_SIGNED',
  contractSend: 'CONTRACT_SENT',
  SendBacktoAccountManager: 'Waiting_On_Account_Manager',
  SendBacktoPreSalesEngineer: 'Waiting_On_Pre_Sales_Engineer',
  pendingApproval: "PENDING_APPROVAL",
  quoteApproved: "QUOTE_APPROVED",
  quoteRejected: "QUOTE_REJECTED",
  approved: 'Approved',
  pendingApprovalOCDR: 'Pending-Approval',
  autoApproved: 'Auto-Approved',
  rejected: 'Rejected'
};
export const quoteStatus = {
  incomplete: 'INCOMPLETE',
  pendingApproval: 'PENDING_APPROVAL',
  approved: 'QUOTE_APPROVED',
  rejected: 'QUOTE_REJECTED'
};

export const discountFilterStatuses = {
  approved: 'Approved',
  pendingApproval: 'Pending-Approval',
  autoApproved: 'Auto-Approved',
  rejected: 'Rejected'
};

export const wlnFilterStatuses = {
  incomplete: 'INCOMPLETE',
  quoteComplete: 'QUOTE_COMPLETE',
  orderIncomplete: 'ORDER_INCOMPLETE',
  submitted: 'SUBMITTED',
  pendingValidation: 'PENDING_VALIDATION',
  inProgress: 'IN_PROGRESS',
  actionRequired: 'ACTION_REQUIRED',
  completed: 'COMPLETED',
  orderCanceled: 'ORDER_CANCELED',
  waitingOnCustomerResponse: 'WAITING_ON_CUSTOMER_RESPONSE',
  waitingOnCredit: 'WAITING_ON_CREDIT',
  waitingOnInternet: 'WAITING_ON_INTERNET',
  waitingOnNTAOrDSR: 'WAITING_ON_NTA_OR_DSR',
  responded: 'RESPONDED'
};

export const fmFilterStatuses = {
  incomplete: 'INCOMPLETE',
  submitted: 'SUBMITTED',
  pendingValidation: 'PENDING_VALIDATION',
  orderCanceled: 'ORDER_CANCELED',
  contractSigned: 'CONTRACT_SIGNED',
  contractSent: 'CONTRACT_SENT',
  sendBacktoAccountManager: 'Waiting_On_Account_Manager',
  sendBacktoSalesRep: 'Waiting_On_Pre_Sales_Engineer',
  pendingApproval: "PENDING_APPROVAL",
  quoteApproved: "QUOTE_APPROVED",
  quoteRejected: "QUOTE_REJECTED",
  SendBacktoAccountManager: 'Waiting_On_Account_Manager'
};

export const roleName = {
  SALES_REP: 'SALES_REP'
};

export const secureBusinessLegalNameFieldTypes = {
  businessLegalName: 'businessLegalName',
  businessLegalNameNonProfit: 'businessLegalNameNonProfit',
  businessLegalNamePersonal: 'businessLegalNamePersonal'
};

export const businessLegalNameQuoteTool = 'businessLegalNameQuoteTool';

// Fields for office Phone
export const fieldOfficePhoneType = 'type';
export const fieldOfficePhoneSetup = 'setup';
export const fieldOfficeRatePlan = 'ratePlan';
export const fieldOfficeLineDesignation = 'lineDesignation';
export const fieldOfficePhoneCallingFeatures = 'callingFeatures';
export const fieldOfficePhoneLongDistanceAddons = 'longDistanceAddOns';
export const fieldOfficePhoneregularOffer = 'regularOfferOfficePhone';
export const fieldOfficePhoneTerm = 'term';
export const fieldOfficePhoneTwoMonthsFree = 'twoMonthsDuration';
export const sixByTweleveonthPromo = '6/12monthPromo';
export const fieldOfficePhonelimitedTimeOffer = 'limitedTimeOfferOfficePhone';
export const fieldOfficePhonePricingAndOffers = 'pricingAndOffers';
export const fieldOfficePhoneContractBuyout = 'contractBuyout';
export const officePhoneTerminateContract = 'officePhoneTerminateContract';
export const officePhoneInvoiceTLC = 'officePhoneInvoiceTLC';
export const officePhoneBuyoutPolicy = 'officePhoneBuyoutPolicy';
export const officePhoneCustomerMontlyRate = 'officePhoneCustomerMontlyRate';
export const fieldGisId = 'gisId';
export const fieldBetterBusinessBundleFibre = 'betterBusinessBundleFibre';
export const fieldFiberInternet = 'Fibre Internet';
export const valueFiberInternet = 'Fibre Internet';
export const fieldKeyAddress = 'serviceAddress';
export const feildSourceOfSale = 'sourceOfSale';
export const poeSwitch = 'poeSwitch';
export const poeSwitchZero = 'poeSwitchZero';
export const poeSwitchNonZero = 'poeSwitchNonZero';
export const poeSwitchIncludedEquipment = 'poeSwitchIncludedEquipment';
export const easyPoeSwitchZero = 'easyPoeSwitchZero';
export const easyPoeSwitchNonZero = 'easyPoeSwitchNonZero';
export const fieldPoeSwitchZero = 'poeSwitchZero';
export const fieldPoeSwitchNonZero = 'poeSwitchNonZero';
export const fieldPoeSwitchIncludedEquipment = 'poeSwitchIncludedEquipment';
export const fieldEasyPoeSwitchZero = 'easyPoeSwitchZero';
export const fieldEasyPoeSwitchNonZero = 'easyPoeSwitchNonZero';
export const fieldEasyFiveYearFivePortPoeSwitch =
  'easyFiveYearFivePortPoeSwitch';
export const fieldEasyFiveYearFivePortPoeSwitchPaid =
  'easyFiveYearFivePortPoeSwitchPaid';
export const easPoeSwitch = 'easyPoeSwitchV';
export const poeTurretCamera = 'poeTurretCamera';
export const easyPoeTurret = 'easyPoeTurret';
export const easyFiveYearPoeTurretCamera = 'easyFiveYearPoeTurretCamera';
export const easyFiveYearIndoorCamera = 'easyFiveYearIndoorCamera';
export const easyFiveYearOutdoorCamera = 'easyFiveYearOutdoorCamera';
export const poeTurretCameraFree = 'poeTurretCameraFree';
export const indoorCameraFree = 'indoorCameraFree';
export const outdoorCameraFree = 'outdoorCameraFree';
export const easyIndoorCamera = 'easyIndoorCamera';
export const easyOutdoorCamera = 'easyOutdoorCamera';
export const controlIncludedSdCard = 'controlIncludedSdCard';
export const controlIncludedPaid2TbSvr = 'controlIncludedPaid2TbSvr';
export const microSdCard128Gb = 'microSdCard128Gb';
export const easyMicroSdCard128Gb = 'easyMicroSdCard128Gb';
export const easyFiveYearMicroSdCard128Gb = 'easyFiveYearMicroSdCard128Gb';
export const svr2Tb = 'svr2Tb';
export const easySvr2Tb = 'easySvr2Tb';
export const easyFiveYearTwoTbSVR = 'easyFiveYearTwoTbSVR';

export const poeDomeCameraFree = 'poeDomeCameraFree';
export const indoorCamera = 'indoorCamera';
export const outdoorCamera = 'outdoorCamera';
export const poeDomeCamera = 'poeDomeCamera';
export const temperatureSensor = 'temperatureSensor';
export const temperatureProbe = 'temperatureProbe';
export const easyPoeDome = 'easyPoeDome';
export const easyPoeDomeCamera = 'easyPoeDomeCamera';
export const easyTemperatureSensor = 'easyTemperatureSensor';
export const easyTemperatureProbe = 'easyTemperatureProbe';
// Adding Vulcan Constants for Secure Business Fields
export const protectIncludedPoeSwitchVulcan = 'protectIncludedPoeSwitchVulcan';
export const controlIncludedPoeSwitchVulcan = 'controlIncludedPoeSwitchVulcan';
export const controlIncludedPaid2TbSvrVulcan =
  'controlIncludedPaid2TbSvrVulcan';
export const controlIncludedSdCardVulcan = 'controlIncludedSdCardVulcan';
export const protectIncludedPoeTurretCameraVulcan =
  'protectIncludedPoeTurretCameraVulcan';
export const controlIncludedPoeTurretCameraVulcan =
  'controlIncludedPoeTurretCameraVulcan';

export const indoorCameraVulcan = 'indoorCameraVulcan';
export const easyThreeYearIndoorCameraVulcan =
  'easyThreeYearIndoorCameraVulcan';
export const easyFiveYearIndoorCameraVulcan = 'easyFiveYearIndoorCameraVulcan';
export const outdoorCameraVulcan = 'outdoorCameraVulcan';
export const easyThreeYearOutdoorCameraVulcan =
  'easyThreeYearOutdoorCameraVulcan';
export const easyFiveYearOutdoorCameraVulcan =
  'easyFiveYearOutdoorCameraVulcan';

export const easyThreeYearPoeDomeCameraVulcan =
  'easyThreeYearPoeTurretCameraVulcan';
export const easyFiveYearPoeDomeCameraVulcan =
  'easyFiveYearPoeTurretCameraVulcan';

export const smokeFireDetectorVulcan = 'smokeFireDetectorVulcan';
export const easyThreeYearSmokeFireDetectorVulcan =
  'easyThreeYearSmokeFireDetectorVulcan';
export const easyFiveYearSmokeFireDetectorVulcan =
  'easyFiveYearSmokeFireDetectorVulcan';

export const fivePortPoeSwitchVulcan = 'fivePortPoeSwitchVulcan';
export const easyThreeYearFivePortPoeSwitchVulcan =
  'easyThreeYearFivePortPoeSwitchVulcan';
export const easyFiveYearFivePortPoeSwitchVulcan =
  'easyFiveYearFivePortPoeSwitchVulcan';

export const fivePortPoeSwitchPaidVulcan = 'fivePortPoeSwitchPaidVulcan';
export const easyThreeYearFivePortPoeSwitchPaidVulcan =
  'easyThreeYearFivePortPoeSwitchPaidVulcan';
export const easyFiveYearFivePortPoeSwitchPaidVulcan =
  'easyFiveYearFivePortPoeSwitchPaidVulcan';

export const fieldFivePortPoeSwitchVulcan = 'fivePortPoeSwitchVulcan';
export const fieldFivePortPoeSwitchPaidVulcan = 'fivePortPoeSwitchPaidVulcan';

export const temperatureSensorVulcan = 'temperatureSensorVulcan';
export const easyThreeYearTemperatureSensorVulcan =
  'easyThreeYearTemperatureSensorVulcan';
export const easyFiveYearTemperatureSensorVulcan =
  'easyFiveYearTemperatureSensorVulcan';
export const temperatureProbeVulcan = 'temperatureProbeVulcan';
export const easyThreeYearTemperatureProbeVulcan =
  'easyThreeYearTemperatureProbeVulcan';
export const easyFiveYearTemperatureProbeVulcan =
  'easyFiveYearTemperatureProbeVulcan';
export const microSdCard128GbVulcan = 'microSdCard128GbVulcan';
export const easyThreeYearMicroSdCard128GbVulcan =
  'easyThreeYearMicroSdCard128GbVulcan';
export const easyFiveYearMicroSdCard128GbVulcan =
  'easyFiveYearMicroSdCard128GbVulcan';
export const temperatureMonitoringFiveDollarVulcan =
  'temperatureMonitoringFiveDollarVulcan';
export const temperatureMonitoringTenDollarVulcan =
  'temperatureMonitoringTenDollarVulcan';

export const easyFiveYearTemperatureSensor = 'easyFiveYearTemperatureSensor';
export const easyFiveYearTemperatureProbe = 'easyFiveYearTemperatureProbe';
export const clientEmail = 'Malak.Cheham@telus.com';
export const valueFibreInternet15GSwitchOffer =
  'Fibre Internet 1.5G Switch Offer';
export const valueFibreInternet1GSwitchOffer = 'Fibre Internet 1G Switch Offer';
export const fieldWarningMessageSbsTelesalesProductSelection =
  'warningMessageSbsTelesalesProductSelection';

export const PRE_QUALIFICATION_QUESTIONS = [
  `doesCustomerHaveAnExistingInternetConnection`,
  `wifiAvailable`,
  `lteCoverage`,
  `doesCustomerHaveExistingHardwiredSecuritySetup`,
  `howManySitesDoesCustomerRequirePhysicalSecurityArt`,
  `premiseSize`,
  `doesCustomerRequireAccessControl`,
  `doesCustomerRequireSprinklerSystemMonitoring`,
  `selectCustomerLineOfBusiness`,
  `InstrusionPartitionsPerSite`,
  `maxNumberOfCamerasPerSite`,
  `doesCustomerStoredVideoClip`,
  `cameraResolution`,
  `cameraHeight`,
  `areTherePowerOutlets`,
  `uploadSpeedSupport`,
  `doesTheCustomerHaveFinishedCeiling`,
  `doesCustomerRequireCCTV`,
  `doesCustomerRequireOutdoorSiren`,
  `maxSensorsSupported`
];

export const TSB_ANSWERS = {
  doesCustomerHaveAnExistingInternetConnection: [
    'doesCustomerHaveAnExistingInternetConnectionYes'
  ],
  wifiAvailable: ['wifiAvailableYes'],
  lteCoverage: ['lteCoverageYes'],
  doesCustomerHaveExistingHardwiredSecuritySetup: [
    'doesCustomerHaveExistingHardwiredSecuritySetupNo'
  ],
  howManySitesDoesCustomerRequirePhysicalSecurityArt: [
    'howManySitesDoesCustomerRequirePhysicalSecurityArt_10_and_under'
  ],
  premiseSize: ['premiseSize_up_to_10ksqft', 'premiseSize_up_to_10,000sqft'],
  doesCustomerRequireAccessControl: ['doesCustomerRequireAccessControlNo'],
  doesCustomerRequireSprinklerSystemMonitoring: [
    `doesCustomerRequireSprinklerSystemMonitoringNo`
  ],
  selectCustomerLineOfBusiness: [`selectCustomerLineOfBusiness_other`],
  InstrusionPartitionsPerSite: [`InstrusionPartitionsPerSite_up_to_4`],
  maxNumberOfCamerasPerSite: [`maxNumberOfCamerasPerSite_up_to_8`],
  doesCustomerStoredVideoClip: [`doesCustomerStoredVideoClip_Up_to_2TB`],
  cameraResolution: [`cameraResolution_2mp`],
  cameraHeight: [`cameraHeight_12ft`],
  areTherePowerOutlets: [`areTherePowerOutletsYes`],
  uploadSpeedSupport: [`uploadSpeedSupport_2mb_per_camera`],
  doesTheCustomerHaveFinishedCeiling: [`doesTheCustomerHaveFinishedCeilingNo`],
  doesCustomerRequireCCTV: [`doesCustomerRequireCCTVNo`],
  doesCustomerRequireOutdoorSiren: [`doesCustomerRequireOutdoorSirenNo`],
  maxSensorsSupported: [`maxSensorsSupported32`]
};

export const TSB_PLUS_ANSWERS = {
  doesCustomerHaveAnExistingInternetConnection: [
    'doesCustomerHaveAnExistingInternetConnectionYes'
  ],
  wifiAvailable: ['wifiAvailableYes'],
  lteCoverage: ['lteCoverageYes'],
  doesCustomerHaveExistingHardwiredSecuritySetup: [
    'doesCustomerHaveExistingHardwiredSecuritySetupNo'
  ],
  howManySitesDoesCustomerRequirePhysicalSecurityArt: [
    'howManySitesDoesCustomerRequirePhysicalSecurityArt_over_10'
  ],
  premiseSize: ['premiseSize_up_to_15ksqft', 'premiseSize_up_to_15,000sqft'],
  doesCustomerRequireAccessControl: ['doesCustomerRequireAccessControlNo'],
  doesCustomerRequireSprinklerSystemMonitoring: [
    `doesCustomerRequireSprinklerSystemMonitoringNo`
  ],
  selectCustomerLineOfBusiness: [
    `selectCustomerLineOfBusiness_Churches`,
    `selectCustomerLineOfBusiness_other`
  ],
  InstrusionPartitionsPerSite: [`InstrusionPartitionsPerSite_up_to_4`],
  maxNumberOfCamerasPerSite: [`maxNumberOfCamerasPerSite_up_to_16`],
  doesCustomerStoredVideoClip: [`doesCustomerStoredVideoClip_upto_6tb`],
  cameraResolution: [`cameraResolution_2mp`],
  cameraHeight: [`cameraHeight_15ft`],
  areTherePowerOutlets: [`areTherePowerOutletsYes`],
  uploadSpeedSupport: [`uploadSpeedSupport_2mb_per_camera`],
  doesTheCustomerHaveFinishedCeiling: [`doesTheCustomerHaveFinishedCeilingYes`],
  doesCustomerRequireCCTV: [`doesCustomerRequireCCTVNo`],
  doesCustomerRequireOutdoorSiren: [`doesCustomerRequireOutdoorSirenNo`],
  maxSensorsSupported: [`maxSensorsSupported64`]
};

export const TSB_ENHANCED_ANSWERS = {
  doesCustomerHaveAnExistingInternetConnection: [
    'doesCustomerHaveAnExistingInternetConnectionYes'
  ],
  wifiAvailable: ['wifiAvailableNo'],
  lteCoverage: ['lteCoverageYes'],
  doesCustomerHaveExistingHardwiredSecuritySetup: [
    'doesCustomerHaveExistingHardwiredSecuritySetupNo'
  ],
  howManySitesDoesCustomerRequirePhysicalSecurityArt: [
    'howManySitesDoesCustomerRequirePhysicalSecurityArt_over_10'
  ],
  premiseSize: ['premiseSize_up_to_25ksqft', 'premiseSize_up_to_25,000sqft'],
  doesCustomerRequireAccessControl: ['doesCustomerRequireAccessControlYes'],
  doesCustomerRequireSprinklerSystemMonitoring: [
    `doesCustomerRequireSprinklerSystemMonitoringNo`
  ],
  selectCustomerLineOfBusiness: [
    `selectCustomerLineOfBusiness_transportation`,
    `selectCustomerLineOfBusiness_Logistics/Warehousing`,
    `selectCustomerLineOfBusiness_Independent_Healthcare`,
    `selectCustomerLineOfBusiness_Jeweller`,
    `selectCustomerLineOfBusiness_Car`,
    `selectCustomerLineOfBusiness_Marine/Boat`,
    `selectCustomerLineOfBusiness_Churches`,
    `selectCustomerLineOfBusiness_other`
  ],
  InstrusionPartitionsPerSite: [`InstrusionPartitionsPerSite_up_to_8`],
  maxNumberOfCamerasPerSite: [`maxNumberOfCamerasPerSite_up_to_16`],
  doesCustomerStoredVideoClip: [`doesCustomerStoredVideoClip_Upto8TB`],
  cameraResolution: [`cameraResolution_2mp`, `cameraResolution_5mp`],
  cameraHeight: [`cameraHeight_15ft`],
  areTherePowerOutlets: [`areTherePowerOutletsNo`],
  uploadSpeedSupport: [`uploadSpeedSupport_2mb_per_camera`],
  doesTheCustomerHaveFinishedCeiling: [`doesTheCustomerHaveFinishedCeilingYes`],
  doesCustomerRequireCCTV: [`doesCustomerRequireCCTVYes`],
  doesCustomerRequireOutdoorSiren: [`doesCustomerRequireOutdoorSirenNo`],
  maxSensorsSupported: [`maxSensorsSupported64`]
};

export const TCSS_ANSWERS = {
  doesCustomerHaveAnExistingInternetConnection: [
    'doesCustomerHaveAnExistingInternetConnectionNo'
  ],
  wifiAvailable: ['wifiAvailableNo'],
  lteCoverage: ['lteCoverageNo'],
  doesCustomerHaveExistingHardwiredSecuritySetup: [
    'doesCustomerHaveExistingHardwiredSecuritySetupYes'
  ],
  howManySitesDoesCustomerRequirePhysicalSecurityArt: [
    'howManySitesDoesCustomerRequirePhysicalSecurityArt_over_10'
  ],
  premiseSize: ['premiseSize_Over_25ksqft', 'premiseSize_Over_25,000sqft'],
  doesCustomerRequireAccessControl: ['doesCustomerRequireAccessControlYes'],
  doesCustomerRequireSprinklerSystemMonitoring: [
    `doesCustomerRequireSprinklerSystemMonitoringYes`
  ],
  selectCustomerLineOfBusiness: [
    `selectCustomerLineOfBusiness_public_sector`,
    `selectCustomerLineOfBusiness_retail_banking`,
    `selectCustomerLineOfBusiness_smart_city`,
    `selectCustomerLineOfBusiness_cannabis_grow`,
    `selectCustomerLineOfBusiness_cannabis_stores`,
    `selectCustomerLineOfBusiness_transportation`,
    `selectCustomerLineOfBusiness_Logistics/Warehousing`,
    `selectCustomerLineOfBusiness_AgTech`,
    `selectCustomerLineOfBusiness_MDU/Smart`,
    `selectCustomerLineOfBusiness_FrontLobbies`,
    `selectCustomerLineOfBusiness_Independent_Healthcare`,
    `selectCustomerLineOfBusiness_Jeweller`,
    `selectCustomerLineOfBusiness_Car`,
    `selectCustomerLineOfBusiness_Marine/Boat`,
    `selectCustomerLineOfBusiness_Churches`,
    `selectCustomerLineOfBusiness_ArtGalleries`,
    `selectCustomerLineOfBusiness_hotels`,
    `selectCustomerLineOfBusiness_other`
  ],
  InstrusionPartitionsPerSite: [`InstrusionPartitionsPerSite_over_8`],
  maxNumberOfCamerasPerSite: [`maxNumberOfCamerasPerSite_over_to_16`],
  doesCustomerStoredVideoClip: [`doesCustomerStoredVideoClip_over8tb`],
  cameraResolution: [`cameraResolution_over_5mp`],
  cameraHeight: [`cameraHeight_over_15ft`],
  areTherePowerOutlets: [`areTherePowerOutletsNo`],
  uploadSpeedSupport: [`uploadSpeedSupport_over_2mb_per_camera`],
  doesTheCustomerHaveFinishedCeiling: [`doesTheCustomerHaveFinishedCeilingYes`],
  doesCustomerRequireCCTV: [`doesCustomerRequireCCTVYes`],
  doesCustomerRequireOutdoorSiren: [`doesCustomerRequireOutdoorSirenYes`],
  maxSensorsSupported: [`maxSensorsSupported_over_64`]
};

export const modeOfPaymentValues = {
  MONTH_TO_MONTH: 'monthly',
  ONE_TIME: 'oneTime',
  MONTHLY_FIVE_YEAR: 'monthlyFiveYear'
};
export const a = {};
// Backend keys
export const BACKEND_KEYS = {
  customerInformation: 'customerInformation',
  orderCustomerInformation: 'orderCustomerInformation',
  productInformation: 'productInformation',
  officePhone: 'officePhone',
  quoteSummary: 'quoteSummary',
  officeInternetFiber: 'fibreInternet',
  officeInternetCopper: 'internetCopper',
  basicWifiAp: 'twBasicWifiAp',
  optikTv: 'telusOptikTv',
  secureBusinessStep: 'telusSecureBusiness',
  salesOrderChecklist: 'salesOrderChecklist',
  orderSummary: 'orderSummary',
  orderSummaryForm: 'orderSummaryForm',
  billingAddress: 'billingAddress',
  serviceOrShippingAddress: 'serviceOrShippingAddress',
  winbackInstallationOrderStep: 'winbackInstallationOrderStep',
  wirelessOrderDetailsStep: 'wirelessOrderDetails',
  wirelessOrderDetails: 'wirelessOrderDetails',
  telusBusinessWifiHSIA: 'telusBusinessWifiHSIA'
};

export const FIELDS_NAMES = {
  province: 'province',
  city: 'city',
  postalCode: 'postalCode',
  streetAddress: 'streetAddress'
};

export const ORDER_STATUSES = {
  complete: 'complete'
};

export const officePhoneRowTypes = {
  mainRow: 'mainRow',
  ovLine: 'ovLine'
};

// generic Fields
export const typePassword = 'password';
export const typeCheckbox = 'Checkbox';

export const serviceAddressValue = 'serviceAddressValue';
export const officePhoneFieldValues = {
  type: {
    multiLine,
    ovLine
  },
  ratePlan: {
    opBasic,
    op,
    opPlus,
    opUtility
  },
  setup: {
    new: New,
    winback
  },
  term: {
    monthToMonth: monthly,
    threeYearTerm: yearsTerm,
    fiveYearTerm: fiveYearsTerm
  },
  regularOffer: {
    standard: standardMonthlyPricing,
    // sixTwelveMonth: sixTwelveMonthPromo,
    // sixTwelveMonthBackPocket: sixTwelveMonthPromoBackpocket
  },
  twoMonthsDuration: {
    yes,
    no
  },
  tollFree: {
    yes,
    no
  },
  forbearance: {
    forborne: unRegulated,
    nonForborne: tariffed
  },
  pricingAndOffers: {
    mtmPrice,
    sixTwelveMonthPromo
  }
};
// field names
// field names copper
export const fieldWinback = 'winback';
export const fieldStaticIPRequired = 'staticIPRequired';
export const fieldStaticIpSubnet1 = 'staticIpSubnet1';
export const fieldStaticIpSubnet5 = 'staticIpSubnet5';
export const fieldStaticIp5 = 'staticIp5';
export const staticIpSubnet1Label =
  'Static IP Subnet - 1 IP (at $12 per month)';
export const staticIpSubnet5Label =
  'Static IP Subnet - 5 IP (at $20 per month)';
export const staticIp5Label = '5 Static IP (at $ 12/ Per month)';
export const staticIp5LabelPromotion = 'Static IP Subnet - 5 IP for $0';
export const fieldStaticIpPromotion = 'staticIpPromotion';

export const fieldQualifiedSpeed = 'qualifiedSpeed';
export const fieldTerm = 'term';
export const fieldTwoMonthsDuration = 'twoMonthsDuration';
export const fieldRegularYearlyOffers = 'regularOffers36MonthTerm';
export const fieldRegularMonthlyOffers = 'regularMonthlyOffers';
export const fiveYearlyCopperPromos = 'fiveYearlyCopperPromos';
export const fiveYearlyFibrePromos = 'fiveYearlyFibrePromos';
export const blackFridayPromos = 'blackFridayPromos';
export const switchCredit$100 = 'switchCredit100';
export const highSpeedFibreBillCredit = 'billCreditFibre';
export const billCredit100 = '$100 Bill Credit';
export const internetAndBusinessConnectBundleBillCredit200 =
  '$200 Internet and Business Connect Bundle Bill Credit';
export const contractBuyoutBillCredit300 = '$300 Contract Buyout Bill Credit';
export const contractBuyoutBillCredit600 = '$600 Contract Buyout Bill Credit';
export const optionHighSpeedBillCredit600 = '$600 Bill Credit';
export const optionHighSpeedBillCredit800 = '$800 Bill Credit';
export const optionHighSpeedBillCredit900 = '$900 Bill Credit';
export const switchCreditCopper = 'switchCreditCopper';
export const switchCreditValue = '$100 Switch Credit';
export const none = 'None';
export const sixMonthsFreePromo = '6monthsFree';
export const fiveDollarsOff = '$5off';
export const fieldLimitedTimeOffer = 'limitedTimeOffer';
export const fieldLimitedTimeBasicOffer = 'limitedTimeBasicOffer';
export const fieldLimitedYearlyOffersFibre150 = 'limitedYearlyOffersFibre150';
export const fieldLimitedYearlyOffersFibre300 = 'limitedYearlyOffersFibre300';
export const fieldLimitedTimeOfferYearly3g3000 =
  'limitedTimeOfferYearly3g_3000';
export const fieldProductThatIsAdded = 'productThatIsAdded';
export const fieldSigningAuthority = 'Signing Authority';
export const fieldContractLanguagePreference = 'contractLanguagePreference';
export const fieldDoesCustomerHaveLawnOrFenceOnPremise =
  'doesCustomerHaveLawnOrFenceOnPremise';
export const fieldEmergencyPremiseContactNumber =
  'repeatedFormemergencyContactDetailspremiseContactNumber_emergencyContactDetails0';
export const fieldEmergencyExtension =
  'repeatedFormemergencyContactDetailsextension_emergencyContactDetails0';
export const fieldIsThisHomeBasedBusiness = 'isThisHomeBasedBusiness';
export const fieldEmergencyExtensionNonRepeated =
  'extension_emergencyContactDetails';
export const fieldEmergencyExtensionNonRepeatedVulcan =
  'extension_emergencyContactDetailsVulcan';
export const fieldEmergencyPremiseContactNumberNonRepeated =
  'premiseContactNumber_emergencyContactDetails';
export const fieldEmergencyPremiseContactNumberNonRepeatedVulcan =
  'premiseContactNumber_emergencyContactDetailsVulcan';
export const hasQuebecServiceAddress = ['Quebec', 'Que.', 'QC'];
export const valueQuebec = ['Quebec', 'quebec'];
export const fieldpreferredLanguageOfContact = 'preferredLanguageOfContact';
export const fieldpreferredLanguageOfContactOne =
  'preferredLanguageOfContactOne';
export const fieldpreferredLanguageOfContactTwo =
  'preferredLanguageOfContactTwo';
export const fieldEmergencyContactDetails = 'emergencyContactDetails';
export const fieldEmergencyContactDetailsVulcan =
  'emergencyContactDetailsVulcan';
export const fieldAccountDetails = 'Account Details';
export const fieldAccountDetailsVulcan = 'Account Details.';
export const fieldAccountDetailsFr = 'Détails du compte';
export const fieldEmergencyPassword = 'password_emergencyContactDetails';
export const setup = 'setup';
export const tollFree = 'tollFree';
export const wirelinePreferedInstallDate = 'wirelinePreferedInstallDate';
export const wirelineSecondaryInstallDate = 'wirelineSecondaryInstallDate';
export const tsbPreferedInstallDate = 'tsbPreferedInstallDate';
export const tsbSecondaryPreferredInstallDate =
  'tsbSecondaryPreferredInstallDate';
export const formCategoryWirelineSecureBusiness =
  'wireline and secure business';
export const formCategoryReferrals = 'referrals';
export const formCategoryBrp = 'brp webform';
export const formCategoryFM = 'fully managed';
export const managedDetectionResponse = 'Managed Detection & Response (MDR)';
// field names fiber
export const fieldWinbackFibre = 'isThisAWinbackFibre';
export const newAndAcquired = {
  yes: 'doesCustomerSiteHaveAnExistingSecuritySystemYes',
  no: 'doesCustomerSiteHaveAnExistingSecuritySystemNo',
  key: 'doesCustomerSiteHaveAnExistingSecuritySystem'
};

export const MM_CHANNELS_FLOW_KEYS = {
  newOrAquiredCustomer: 'newOrAquiredCustomer',
  doesCustomerHaveAnExistingInternetConnection:
    'doesCustomerHaveAnExistingInternetConnection',
  doesCustomerSiteHaveAnExistingSecuritySystem:
    'doesCustomerSiteHaveAnExistingSecuritySystem',
  howManySitesDoesCustomerRequirePhysicalSecurityArt:
    'howManySitesDoesCustomerRequirePhysicalSecurityArt',
  selectCustomerLineOfBusiness: 'selectCustomerLineOfBusiness',
  doesCustomerStoredVideoClip: 'doesCustomerStoredVideoClip',
  internetAvailable: 'internetAvailable',
  wifiAvailable: 'wifiAvailable',
  lteCoverage: 'lteCoverage',
  doesCustomerHaveExistingHardwiredSecuritySetup:
    'doesCustomerHaveExistingHardwiredSecuritySetup',
  noOfSites: 'noOfSites',
  premiseSize: 'premiseSize',
  doesCustomerRequireAccessControl: 'doesCustomerRequireAccessControl',
  doesCustomerRequireSprinklerSystemMonitoring:
    'doesCustomerRequireSprinklerSystemMonitoring',
  InstrusionPartitionsPerSite: 'InstrusionPartitionsPerSite',
  maxNumberOfCamerasPerSite: 'maxNumberOfCamerasPerSite',
  cameraResolution: 'cameraResolution',
  cameraHeight: 'cameraHeight',
  uploadSpeedSupport: 'uploadSpeedSupport',
  doesTheCustomerHaveFinishedCeiling: 'doesTheCustomerHaveFinishedCeiling',
  doesCustomerRequireCCTV: 'doesCustomerRequireCCTV',
  doesCustomerRequireOutdoorSiren: 'doesCustomerRequireOutdoorSiren',
  areTherePowerOutlets: 'areTherePowerOutlets',
  maxSensorsSupported: 'maxSensorsSupported',
  acquiredCustomerTextErrorMesssage: 'acquiredCustomerTextErrorMesssage'
};
export const fieldLimitedOfferFI = 'limitedOfferFI';
export const fieldFiberInternet75BFPromo =
  'Fibre Internet 75 Black Friday promo';
export const fieldFiberInternet75G1 = 'Fibre Internet 75 promo (CBM Group 1)';
export const fieldFibreInternet75G2 = 'Fibre Internet 75 promo (CBM Group 2)';
export const fieldFibreInternet75MPP = 'Fibre Internet 75 promo (MPP)';
export const fieldFiberInternetG1promo = 'Fibre Internet 1G promo';
export const fibreInternet15gPromo = 'Fibre Internet 1.5 promo';
export const fibreInternet3GPromo = 'Fibre Internet 3G promo';
export const fieldFiberInternetG1 = 'Fibre Internet 1G promo (CBM Group 1)';
export const fieldFiberInternetG2 = 'Fibre Internet 1G promo (CBM Group 2)';
export const fieldFiberInternetMPP = 'Fibre Internet 1G promo (MPP)';
export const fieldLimitedYearlyOffersFibreFiveG =
  'limitedYearlyOffersFibreFiveG';
export const valueOptionFibreInternet5GPromo = 'Fibre Internet 5G Promo';
export const fieldFiberSwitch15GSwitch = 'Fibre Internet 1.5G Switch Offer';
export const fieldFiberSwitch1GSwitch = 'Fibre Internet 1G Switch Offer';
export const fieldStaticIPRequiredFibre = 'staticIPRequiredFibre';
export const fieldStaticIpPromotionFibre = 'staticIpPromotion';
export const fieldOptionStaticIp5 = 'staticIp5';
export const fieldOptionStaticIpDynamic5 = 'staticIpDynamic5';
export const fieldOptionStaticIp0 = 'staticIpSubnet0';
export const fieldQualifiedSpeedFibre = 'qualifiedSpeedFibre';
export const fieldTermFibre = 'termFibre';
export const fieldTwoMonthsDurationFibre = 'twoMonthsFreeFibre';
export const fieldRegularMonthlyOffersFibre = 'regularMonthlyOffersFibre';
export const fieldRegularYearlyOffersFibre = 'regularYearlyOffersFibre';
export const fieldRegularYearlyOffersFibreBundled =
  'regularYearlyOfferFibreBundled';
export const fieldPromoDurationFibre = 'promoDurationFibre';
export const fieldPermitNumberUserAccountDetail =
  'permitNumber_userAccountDetail';
export const fieldPermitNumberUserAccountDetailVulcan =
  'permitNumber_userAccountDetailVulcan';
export const telusPublicWifiFibre = 'telusPublicWifiFibre';

export const numberTelusWifiAccessPoints = 'numberTelusWifiAccessPoints';
// export const errorNumberTelusWifiAccessPoints =
//   'A maximum of 3 access points can be added to this order.';
export const telusBusinessWifi = 'telusBusinessWifi';
export const numberTelusWifiAccessPointsTelusBusiness =
  'numberTelusWifiAccessPointsTelusBusiness';
export const numberTelusWifiAccessPointsFibre =
  'numberTelusWifiAccessPointsFibre';
// export const tbWifiAccessPointsFibre = 'tbWifiAccessPointsFibre';
export const numberTelusWifiAccessPointsCopper =
  'numberTelusWifiAccessPointsCopper';
export const telusBusinessWifiType = 'telusBusinessWifiType';
export const fieldTelusBusinessWifi = 'telusBusinessWifi';
export const fieldTelusBusinessWifiTypeTelusBusiness =
  'telusBusinessWifiTypeTelusBusiness';
export const fieldTelusBusinessWifiTypeFibre = 'telusBusinessWifiTypeFibre';
export const fieldTelusBusinessWifiTypeCopper = 'telusBusinessWifiTypeCopper';
export const numberTelusAccessPoints = 'numberTelusAccessPoints';
export const fieldLimitedTimeOfferYearly15g = 'limitedTimeOfferYearly15g';
export const fieldMppOffers = 'mppOffers';
export const fieldTelusOptikTvProfileType = 'telusOptikTvProfileType';
export const fieldThreeTierCommunityOptik = 'threeTierCommunityOptik';
export const fieldBusinessTVmigrationOptik = 'businessTVmigrationOptik';
export const homeBasedBusiness = 'Home Based Business';
export const basics = 'Basics';

export const mppCrossSellOffer15 = '$15 MPP cross-sell offer';
export const mppFibreInternet1G = 'MPP: $90 Fibre Internet 1G';

// field names product information
export const fieldCustomerSecuritySystems = 'customerSecuritySystems';
export const fieldtelusOptikTvAccessibleToEmpAndStaff =
  'telusOptikTvAccessibleToEmpAndStaff';
// eslint-disable-next-line camelcase
export const fieldCustomerRequestFibre3G = 'customerRequestFibre3G';
export const fieldProductSelection = 'productSelection';
export const fieldSpecialRetailer = 'isthisSpecialRetailer';
export const fieldHighValueItems = 'isProtectingHighValueItems';
export const fieldInboundOutbound = 'inboundOutbound';
export const fieldBuildingSize = 'isBuildingOverSize';
export const fieldEightCameras = 'moreThanEightCameras';
export const fieldCamerasInstalled = 'camerasInstalledAtHeight';
export const complexNote = 'complexNote';
export const telusTVforBusiness = 'TELUS TV for Business';
export const selfInstall = 'Self Install (DIY)';
export const waivedMultiProductOrder =
  'Waived Professional Install (Multi Product Order)';
export const waivedMovingFromCompetitor =
  'Waived Professional Install (If moving from a competitor)';
export const fieldTermBusinessTV = 'termBusinessTV';
export const smbPlatinum = 'smbPlatinum';
export const channelComplexNote = 'channelComplexNote';
export const warningNote = 'warningNoteOptikTV';
export const warningNoteSmbTiDigitalFr = 'warningNoteSmbTiDigitalFr';
export const existingConnection = 'existingConnection';
export const telusUpgrade = 'telusUpgrade';
export const customerAuthorized = 'customerAuthorized';
export const customerAuthorizedValcan = 'customerAuthorizedVulcan';
export const existingConnectionYes = 'existingConnectionYes';
export const existingNo = 'existingNo';
export const telusYes = 'telusYes';
export const telusNo = 'telusNo';
export const telusCaseNumber = 'telusCaseNumber';
export const telusUploadSpeed = 'telusUploadSpeed';
export const existingProvider = 'existingProvider';
export const wifiPrivate = 'wifiPrivate';
export const uploadSpeedTrue = 'uploadSpeedTrue';
export const upgradeCaseNumber = 'upgradeCaseNumber';
export const uploadSpeedLogic = 'uploadSpeedLogic';
export const wifiSecurityErrorNote = 'wifiSecurityErrorNote';
export const fieldsKeyLocalStorage = 'fieldsObject';
export const fieldsKeyLegalBusinessName = 'legalBusinessName';
export const fieldExpirationKey = 'expirationDate_userAccountDetail';
export const fieldExpirationKeyVulcan =
  'expirationDate_userAccountDetailVulcan';
export const valueNonProfitOrgs = 'Non-Profit Orgs';
export const valueBusinessPersonal = 'Business Personal';
export const valueBusinessRegular = 'Business Regular';
export const valueSixmonths = '6months';
export const valueNewTelusBusinessOrder = 'newTelusBusinessOrder';
export const fieldPromoDuration = 'promoDuration';

export const existingConnectionMapping = {
  Yes: existingConnectionYes,
  No: existingNo
};
export const telusUpgradeMapping = {
  Yes: telusYes,
  No: telusNo
};

export const fieldLimitedMonthlyOfferFibre = 'limitedMonthlyOfferFibre';
export const fieldLimitedMonthlyOfferFibre75 = 'limitedMonthlyOfferFibre75';
export const fieldSecureBusiness = 'Secure Business';
export const fieldMobility = 'Mobi-lity';
export const fieldTVBasic = 'Optik TV Basic';
export const monthlyPlanOptions = ['Basics (BTL)', 'Core', 'Choices', 'More Choices'];

export const fieldBusinessConnect = 'Business Connect';
export const fieldTelusBusinessWifiOption = 'Telus Business Wi-Fi';
export const fieldLimitedMontlyOfferFibre3G = 'limitedMonthlyOfferFibre3G';
export const fieldLimitedYearlyOffersFibre = 'limitedYearlyOffersFibre';
export const fieldProductSelectionFibre = 'productSelectionFibre';
export const fieldTwoMonthsFreeFibre = 'twoMonthsFreeFibre';
export const fieldProductType = 'productType';
export const valueProductTypeStandaloneFr = 'autonome';
// telus optik fields
export const fieldTelusOptikTvMonthlyRatePlan = 'telusOptikTvMonthlyRatePlan';
export const fieldCustomerHaveLiquorLicense = 'customerHaveLiquorLicense';

export const fieldTelusOptikTvIsThisAWinback = 'telusOptikTvIsThisAWinback';
export const fieldInstallation = 'installation';
export const fieldTelusOptikTvPricingAndOffers = 'telusOptikTvPricingAndOffers';
export const fieldTelusOptikTvTwoMonthFree = 'telusOptikTvTwoMonthFree';
export const fieldTelusOptikTvPromoDuration = 'telusOptikTvPromoDuration';
export const fieldTelusOptikTvFreeThemePacks = 'telusOptikTvFreeThemePacks';
export const fieldTelusOptikTvFreeThemePacksForHomeBased =
  'telusOptikTvFreeThemePacksForHomeBased';
export const fieldTelusOptikTvExtraThemePackHomeBased =
  'telusOptikTvExtraThemePackHomeBased';
export const allowedChannelsListForHomeBased = [
  'SMB Growth Sales W 2A',
  'SMB Growth Sales W 2B',
  'SMB Growth Sales W 2C',
  'SMB Growth Sales W 2D',
  'SMB Growth Sales W 1A',
  'SMB Growth Sales W 1B',
  'SMB Growth Sales W 1C',
  'SMB Growth Sales W 1D',
  'SMB Growth Sales 30 to 100 2A',
  'SMB Growth Sales 30 to 100 2B',
  'SMB Growth Sales 30 to 100 2C',
  'SMB Retention Sales 30 to 100 2D',
  'SMB Growth Sales Advance WEST',
  'SMB New Growth Market 1',
  'SMB New Growth Market 2',
  'White Glove NBD Technicians',
  'SMB TI Sales Digital',
  'SMB TI Sales Base Management',
  'SMB TI ADT Retention',
  'SMB TI Digital - EN',
  'SMB TI Digital - FR',
  'SMB TI HSIA Growth',
  'SMB TI NBS Value Add',
  'SMB TI WLN Retention',
  'SMB TI WLS Growth QC',
  'SMB TI WLS Growth ROC',
  'SBS Telesales TI',
  'SMB RFS 1',
  'SMB RFS 2',
  'SMB L&R 2',
  'SMB L&R 3',
  'SMB L&R 4',
  'SMB L&R 5',
  'SMB L&R TI',
  'SMB L&R TI 2',
  'SMB L&R TI 3',
  'DEALER'
];
export const allowedProvinceListForDealers = ['ALBERTA', 'BRITISH_COLUMBIA'];
export const fieldSigningAuthorityV = 'signingAuthority';
export const feildBetterBusinessBundleCopper = 'betterBusinessBundleCopper';
export const feildBetterBusinessBundleFibre = 'betterBusinessBundleFibre';
export const sectionTelusOptikTvInstallDetails =
  'telusOptikTvInstallDetailsSection';
export const keyTelusOptikTvAdditionalSetTopBoxes =
  'telusOptikTvAdditionalSetTopBoxes';
export const fieldTelusOptikTvNumberWiredSetTopBoxes =
  'telusOptikTvNumberWiredSetTopBoxes';
export const fieldTelusOptikTvNumberWirelessSetTopBoxes =
  'telusOptikTvNumberWirelessSetTopBoxes';
export const fieldTelusOptikTvAdditionalSetTopBox =
  'telusOptikTvAdditionalSetTopBox';
export const fieldServiceAndShipping = 'Shipping Address';
export const keyStreetAddressBillingAddress = 'streetAddress_billingAddress';
export const keyStreetAddressServiceOrShippingAddress =
  'streetAddress_serviceOrShippingAddress';
export const keyProvinceServiceOrShippingAddress =
  'province_serviceOrShippingAddress';
export const keyCityServiceOrShippingAddress = 'city_serviceOrShippingAddress';
export const keyPostalCodeServiceOrShippingAddress =
  'postalCode_serviceOrShippingAddress';

export const fieldOrderType = 'orderType';
export const fieldInternetType = 'internetType';

// field name TW Basic Wifi AP
export const fieldTwBasicWifiApAmount = 'twBasicWifiAp_Amount';

// Field values
export const valueCustomerInformation = 'customerInformation';
export const valueProductInformation = 'productInformation';
export const valueCustomerExistingServices = 'customerExistingServices';
export const fieldValueHSIA = 'HSIA (Copper/Fibre)';
export const fieldLeadID = 'Unique7xID';
export const internetTypesOptionLables = [
  'copperToFiberMigration',
  'mtmToContactMigration'
];
// Order Type
export const orderTypeNew = 'New';

// Payload Keys
export const keyServiceAddresses = 'serviceAddresses';
export const keyOfficePhoneData = 'officePhoneData';
export const keyEmergencyContact = 'emergencyContactDetails';
export const keySecureBusiness = 'Secure Business';
export const keyYes = 'yes';
export const fibreNoteOnCustomerInfomationPage =
  'fibreNoteOnCustomerInfomationPage';
export const fibreNoteCheckbox = 'fibreNoteCheckbox';
// formstepname

export const internetCopper = 'Office Internet Copper';
export const internetFibre = 'Fibre Internet';
export const telusSecureBusiness = 'Secure Business';
export const fieldObdOrder = 'obdOrder';
export const telusOptictvTimeZone = 'telusOptictvTimeZone';
export const fieldObdNoteOnCustomerInformation = 'obdNoteOnCustomerInformation';

// Telus Secure Business
export const cameraTypeList = ['Camera', 'PoE Camera'];
export const secureBusinessAllowedChannelsList = [
  'ISS_ONTARIO',
  'ISS_ALBERTA',
  'ISS_BRITISH_COLUMBIA',
  'DEALER'
];
export const fieldSecureBusinessOffers = 'secureBusinessOffers';
export const fieldSmartCameraOffers = 'smartCameraOffers';
export const smartCameraKey = 'smartCamera';
export const secureBusinessTerm = 'secureBusinessTerm';
export const fieldTelusSecureBusinessSecurityPackage =
  'telusSecureBusinessSecurityPackage';
export const vulcanTerm = 'termVUL';
export const secureBusinessPlanVulcan = 'secureBusinessPlanVulcan';
export const Prequalification = 'Prequalification';
export const fieldPoeSwitch = 'poeSwitch';
export const fieldPoeSwitchFree = 'poeSwitchFree';
export const typePoeCamera = 'PoE Camera';
export const typeSwitch = 'Switch';
export const keyMonitorAdditionalEquipment = 'monitorAdditionalEquipment';
export const keySecurityCameraEquipment = 'smartcameraAdditionalEquipment';
export const keySmartCameraIncludedEquipment = 'smartcameraIncludedEquipment';
export const keyMonitorIncludedEquipment = 'monitorIncludedEquipment';
export const keyProtectIncludedEquipment = 'protectIncludedEquipment';
export const keyProtectIncludedEquipmentSelection =
  'protectIncludedEquipmentSelection';
export const keyProtectAdditionalEquipment = 'protectAdditionalEquipment';
export const keyControlIncludedEquipment = 'controlIncludedEquipment';
export const keyControlAdditionalEquipment = 'controlAdditionalEquipment';
// Adding keynames being used in Vulcan Secure Business
export const keyMonitorVulcan = 'Monitor';
export const keyProtectVulcan = 'Protect';
export const keyControlVulcan = 'Control';
export const key3MonthsFree = '3 Months Free';
export const priceMonitorVulcan = -45;
export const priceProtectVulcan = -55;
export const priceControlVulcan = -75;
export const keyMonitorIncludedEquipmentVulcan =
  'monitorIncludedEquipmentVulcan';
export const keyProtectIncludedEquipmentVulcan =
  'protectIncludedEquipmentVulcan';
export const keyControlIncludedEquipmentVulcan =
  'controlIncludedEquipmentVulcan';
export const keyProtectIncludedEquipmentCameraSelectionVulcan =
  'protectIncludedEquipmentCameraSelectionVulcan';
export const keyControlIncludedEquipmentCameraSelectionVulcan =
  'controlIncludedEquipmentCameraSelectionVulcan';
export const keyProtectAdditionalEquipmentVulcan =
  'protectAdditionalEquipmentVulcan';
export const keyMonitorAdditionalEquipmentVulcan =
  'monitorAdditionalEquipmentVulcan';
export const keyControlAdditionalEquipmentVulcan =
  'controlAdditionalEquipmentVulcan';
export const protectIncludedEquipmentCameraSelectionVulcan =
  'protectIncludedEquipmentCameraSelectionVulcan';
export const controlIncludedEquipmentCameraSelectionVulcan =
  'controlIncludedEquipmentCameraSelectionVulcan';
export const secureBusinessSectionsVulcan = [
  keyMonitorIncludedEquipmentVulcan,
  keyProtectIncludedEquipmentVulcan,
  keyProtectIncludedEquipmentCameraSelectionVulcan,
  keyControlIncludedEquipmentVulcan,
  keyControlIncludedEquipmentCameraSelectionVulcan,
  keyMonitorAdditionalEquipmentVulcan,
  keyProtectAdditionalEquipmentVulcan,
  keyControlAdditionalEquipmentVulcan
];
export const monitorSectionsVulcan = [
  keyMonitorIncludedEquipmentVulcan,
  keyMonitorAdditionalEquipmentVulcan
];
export const protectSectionsVulcan = [
  keyProtectIncludedEquipmentVulcan,
  keyProtectIncludedEquipmentCameraSelectionVulcan,
  keyProtectAdditionalEquipmentVulcan
];
export const controlSectionsVulcan = [
  keyControlIncludedEquipmentVulcan,
  keyControlIncludedEquipmentCameraSelectionVulcan,
  keyControlAdditionalEquipmentVulcan
];

export const controlIncludedIndoorCameraVulcan =
  'controlIncludedIndoorCameraVulcan';
export const controlIncludedOutdoorCameraVulcan =
  'controlIncludedOutdoorCameraVulcan';
export const smokeDetectorWarningNoteVulcan = 'smokeDetectorWarningNoteVulcan';
export const temperatureSensorFeeNote1Vulcan =
  'temperatureSensorFeeNote1Vulcan';
export const temperatureSensorFeeNote2Vulcan =
  'temperatureSensorFeeNote2Vulcan';

export const keyControlIncludedEquipmentSelection =
  'controlIncludedEquipmentSelection';
export const FibreInternet150CBMGroup1 =
  'Fibre Internet 150 promo (CBM Group 1)';
export const FibreInternet150CBMGroup2 =
  'Fibre Internet 150 promo (CBM Group 2)';
export const FibreInternet150 = 'Fibre Internet 150 promo';
export const FibreInternet300 = 'Fibre Internet 300 promo';
export const FibreInternet300CBMGroup1 =
  'Fibre Internet 300 promo (CBM Group 1)';
export const FibreInternet300CBMGroup2 =
  'Fibre Internet 300 promo (CBM Group 2)';
export const FibreInternet300MPP = 'Fibre Internet 300 promo (MPP)';
export const fieldSmartCamera = 'Smart Camera';
export const fieldProtect = 'Protect';
export const fieldControl = 'Control';
export const valueProtect = 'Protect';
export const valueControl = 'Control';
export const valueMonitor = 'Monitor';
export const fieldDoesCustomerSiteHaveAnExistingSecuritySystem =
  'doesCustomerSiteHaveAnExistingSecuritySystem';

export const includedEquipementErrorMessage =
  'Total number of items should be 3';

export const secureBusinessOppositeSectionKeys = {
  [keySmartCameraIncludedEquipment]: keySecurityCameraEquipment,
  [keySecurityCameraEquipment]: keySmartCameraIncludedEquipment,
  [keyProtectIncludedEquipmentSelection]: keyProtectAdditionalEquipment,
  [keyProtectAdditionalEquipment]: keyProtectIncludedEquipmentSelection,
  [keyControlIncludedEquipmentSelection]: keyControlAdditionalEquipment,
  [keyControlAdditionalEquipment]: keyControlIncludedEquipmentSelection
};
export const secureBusinessOppositeSectionKeysVulcan = {
  [protectIncludedEquipmentCameraSelectionVulcan]: keyProtectAdditionalEquipmentVulcan,
  [keyProtectAdditionalEquipmentVulcan]: protectIncludedEquipmentCameraSelectionVulcan,
  [controlIncludedEquipmentCameraSelectionVulcan]: keyControlAdditionalEquipmentVulcan,
  [keyControlAdditionalEquipmentVulcan]: controlIncludedEquipmentCameraSelectionVulcan
};
export const telusOptikTvSetTopBoxTotalLimit = 5;
export const controlIncludedCameraLimit = 2;
export const secureBusinessMaxCameraLimit = 12;
export const controlIncludedCameraSelectionLimitVulcan = 2;
// Order Section Form Step Keys
export const keySalesOrderChecklist = 'salesOrderChecklist';
export const keyOrderCustomerInformation = 'orderCustomerInformation';
export const keyWinbackInstallationOrderStep = 'winbackInstallationOrderStep';
export const keyOrderSummaryForm = 'orderSummaryForm';
export const keyOrderSummary = 'orderSummary';
export const productSelection = {
  [BACKEND_KEYS.secureBusinessStep]: valueSecureBusiness
};
export const productValuesToBackendKeys = {
  [valueOfficeInternetCopper]: BACKEND_KEYS.officeInternetCopper,
  [valueOfficeInternetFiber]: BACKEND_KEYS.officeInternetFiber,
  [valueOfficePhone]: BACKEND_KEYS.officePhone,
  [valueTelusOptikTv]: BACKEND_KEYS.optikTv,
  [valueSecureBusiness]: BACKEND_KEYS.secureBusinessStep,
  [valueTwBasicWifiAp]: BACKEND_KEYS.basicWifiAp,
  [valueTelusBusinessWifi]: BACKEND_KEYS.telusBusinessWifiHSIA
};
// Order Secure Business
export const fieldTelusAccountNumber = 'telusAccountNumber';

// Province Alias
export const provinceAlias = {
  Alberta: 'AB',
  British_Columbia: 'BC',
  Manitoba: 'MB',
  New_Brunswick: 'NB',
  Newfoundland_and_Labrador: 'NL',
  Northwest_Territories: 'NT',
  Nova_Scotia: 'NS',
  Nunavut: 'NU',
  Ontario: 'ON',
  Prince_Edward_Island: 'PE',
  Quebec: 'QC',
  Saskatchewan: 'SK',
  Yukon: 'YT'
};

// Product Selection
export const productSelectionValues = {
  isthisSpecialRetailer: 'isthisSpecialRetailer',
  isProtectingHighValueItems: 'isProtectingHighValueItems',
  isBuildingOverSize: 'isBuildingOverSize',
  moreThanEightCameras: 'moreThanEightCameras',
  camerasInstalledAtHeight: 'camerasInstalledAtHeight',
  complexNote: 'complexNote',
  channelComplexNote: 'channelComplexNote',
  officeInternetcopper: 'Office Internet Copper',
  telusOptikTV: 'TELUS TV for Business',
  fibreInternet: 'Fibre Internet',
  uploadSpeedBeingSold: 'uploadSpeedBeingSold',
  customerProfileID: 'customerProfileID',
  existingConnection: 'existingConnection',
  complexLeads: 'complexLeads',
  customerSecuritySystems: 'customerSecuritySystems',
  reviewAllQualificationNote: 'reviewAllQualificationNote',
  telusUpgrade: 'telusUpgrade'
};

export const MM_CHANNELS_KEYS_NOTES = {
  customerQualifyForTSB: 'customerQualifyForTSB',
  customerQualifyForTSBPlus: 'customerQualifyForTSBPlus',
  customerQualifyForTSBEnhanced: 'customerQualifyForTSBEnhanced',
  channelComplexNoteForMMChannels: 'channelComplexNoteForMMChannels'
};
export const MM_CHANNELS = ['TELUS_MID_MARKET_QUEBEC', 'TELUS_MID_MARKET'];
export const smbIndirectSalesChannel = 'SMB Indirect Sales';
export const sbsTISalesChannel = 'SBS TI Sales';

export const existingInternetProvider = 'existingInternetProvider';
export const existingInternetProviderAlberta =
  'existingInternetProviderAlberta';
export const privateWifi = 'privateWifi';
export const uploadSpeed = 'uploadSpeed';
export const wifiError = 'wifiError';

export const thirdPartyUrls = {
  complexLeadUrl:
    'https://project.collaborate.tsl.telus.com/sites/TCSSComp/Shared%20Documents/TCSSLeads.html'
};

export const businessType = 'businessType';
export const businessLegalName = 'businessLegalName';
export const administratorContact = 'administratorContact';

export const errorMessage = {
  error_500: {
    message: 'Something went wrong'
  },
  error_413: {
    message: 'File Size Limit exceeded (5MB)'
  },
  required: {
    message: 'Field is Required'
  }
};
export const fieldBusinessRegular = 'Business Regular';
export const fieldBusinessRegularFr = `Régulièr d'affaires`;
export const fieldWLSIncorporationNumber = 'WLSIncorporationNumber';
export const fieldWLSIncorporationDate = 'WLSIncorporationDate';
export const tradeNameOrName = 'tradeNameOrName';
export const smbPlatinumForm = 'smbPlatinumForm';
export const reminder = 'Reminder!';
export const britishColumbia = 'British Columbia';
export const ab = 'AB';
export const mb = 'MB';
export const sk = 'SK';
export const bc = 'BC';
export const manitoba = 'Manitoba';
export const alberta = 'Alberta';
export const saskatchewan = 'Saskatchewan';

export const customerProfileID = 'customerProfileID';
export const fieldBusinessRegularMedium = [
  'Business Regular Medium',
  'Entreprise Régulier Moyen'
];
export const regexBusinessInc =
  'LIMITED|INCORPORATED|CORP|INC|LTD|Ltd|ltd|Inc|inc|Corp|corp|Incorporated|incorporated|ULC|ulc|Limited|limited';
export const errorMessageInc = [
  "A corporation's legal business name must contain either Inc, Ltd, Corp, Incorporated or Limited",
  'Le nom de l’entreprise doit contenir incorporée (inc.), limitée (ltée) ou société.'
];
export const mobileNumber = 'mobileNumber';
export const emailAddress = 'emailAddress';
export const phoneNumber = 'phoneNumber';
export const customerEmailAddress = 'customerEmailAddress';
export const signingAuthority = 'signingAuthority';
export const signingAuthorityFM = 'signingAuthorityFM';
export const signingAuthorityCS = 'signingAuthorityCS';
export const customRequiredMessage = 'Field is Required';

export const statementOfWork = 'statementOfWork';
export const appendices = 'appendices';

export const additionalEquipment = 'Additional Equipment';
export const easyAdditionalEquipment = '3 Year Easy Payment';
export const easyFiveYearAdditionalEquipment = '5 Year Easy Payment';
export const oneTimeAdditionalEquipment = 'One-time Payment';
export const monthlyRecurringAdditionalEquipment = 'Monthly Recuring';
export const standardRate = 'standardRate';
export const standardPricing = 'standardPricing';
export const standardRateLabel = 'Standard Rate';
export const twoMonthsDurationLabel = 'Two months free';
export const sixTwelvePromo = '6/12 Month promo';

export const formCategoriesWirelineWireless = {
  QUOTE_TOOL: 'Quote_tool',
  ORDER_TOOL: 'Order_Details'
};

export const secureBusinessResetFields = {
  existingConnection: 'existingConnection',
  telusUpgrade: 'telusUpgrade',
  existingProvider: 'existingProvider',
  wifiPrivate: 'wifiPrivate',
  privateNo: 'privateNo',
  uploadSpeedTrue: 'uploadSpeedTrue',
  upgradeCaseNumber: 'upgradeCaseNumber',
  uploadSpeedLogic: 'uploadSpeedLogic',
  telusCaseNumber: 'telusCaseNumber',
  telusUploadSpeed: 'telusUploadSpeed',
  existingInternetProvider: 'existingInternetProvider',
  existingInternetProviderAlberta: 'existingInternetProviderAlberta',
  privateWifi: 'privateWifi',
  uploadSpeed: 'uploadSpeed'
};

export const roleLabels = {
  ADMIN: 'Admin',
  SALES_REP: 'Sales Rep',
  SALES_MANAGER: 'Sales Manager',
  TELUS_MANAGER: 'Telus Manager',
  ORDER_FULFILLMENT: 'Order Fulfillment',
  PROPOSAL_HOUSE: 'Proposal House'
};

export const promoDurationValueLabels = {
  '12 months': '12 months',
  '6months':
    '6 months free if take or have 1 other TELUS product (Above the line offer)',
  '6monthFree':
    '6 months free if take or have 1 other TELUS product (Above the line offer)'
};

export const qualifyingQuestionsFieldNames = [
  'isthisSpecialRetailer',
  'isProtectingHighValueItems',
  'isBuildingOverSize',
  'moreThanEightCameras',
  'camerasInstalledAtHeight'
];

export const nonRoSProvinces = ['AB', 'BC'];

export const provinceAdminiterativeLevel = 'administrative_area_level_1';
export const fieldExistingInternetProviderErrorNote =
  'existingInternetProviderErrorNote';
export const fieldExistingInternetProviderRoC = 'existingInternetProviderRoC';
export const storageItemProvince = 'province';
export const localeEnglish = 'en-US';
export const localeFrench = 'fr-CA';
export const stepKeyMain = 'main';

export const oneTimePaymentFields = [
  'controlAdditionalEquipment',
  'smartcameraAdditionalEquipment',
  'monitorAdditionalEquipment',
  'protectAdditionalEquipment'
];

export const fieldServiceAndShippingAddressFr = 'Adresse de service/livraison';

export const valueOfficeInternetBasic = '15/1 mbps';
export const valueTerm36Month = '3yearTerm';
export const valueTerm60Month = '5yearTerm';
export const term36MonthValue = '36 Month Term';
export const term60MonthValue = '60 Month Term';
export const valueThreeMonthsFree = 'threeMonthsFree';
export const valueOfficeInternetBasicPromo = 'officeInternetBasicPromo';
export const limitedTimeOfferBasicPromoPrice = 15;
export const fieldHBBQualificationErrorNote = 'HBBQualificationErrorNote';
export const fieldProductHomeBasedBusiness = 'productHomeBasedBusiness';
export const fieldIsThePurposeToProtectHBB = 'isThePurposeToProtectHBB';
export const fieldDoesCustomerAgreeToAltercations =
  'doesCustomerAgreeToAltercations';
export const fieldIsThisHBBRegisteredBusiness = 'isThisHBBRegisteredBusiness';
export const fieldCustomerServiceAddressNote = 'customerServiceAddressNote';
export const keySecureBusinessFr = 'Produits Sécurité d’entreprise de TELUS';
export const hBBQualificationFields = [
  'isThisHBBRegisteredBusiness',
  'isThisHSIARegisteredToHBB',
  'isThePurposeToProtectHBB',
  'doesCustomerAgreeToAltercations',
  'doesCustomerAgreesToTelusTechnicians'
];
export const tsbSecurityOffersObject = {
  sixMonthsFreeEn: '6 Months Free',
  zeroDollarOffEn: '$0 installation fee',
  twentyDollarOffEn: '$20 off',
  twentyDollarOffFr: '20$ de rabais',
  tenBundleDiscountEn: '$10 Bundle Discount',
  tenBundleDiscountFr: '10 $ de rabais sur le forfait',
  fiveDollarOffEn: '$10 off',
  fiveDollarOffFr: '10$ de rabais'
};
export const fieldPrefferedDateSecurityNote = 'prefferedDateSecurityNote';
export const fieldCustomerPrivateWifiConnection =
  'doesTheCustomerHavePrivateWifiConnection';
export const fieldDoesTheCustomerHaveLteCoverage =
  'doesTheCustomerHaveLteCoverage';
export const fieldLTESpeedErrorNote = 'LTESpeedErrorNote';
export const fieldWhatIsUploadSpeed = 'whatIsUploadSpeed';
export const keyAdditionalEquipment = 'AdditionalEquipment';
export const smartThermostat = 'smartThermostat';
export const smartThermostatFree = 'smartThermostatFree';
export const includedEquipmentSelection = 'IncludedEquipmentSelection';
export const thermostatWarningNote = 'thermostatWarningNote';
export const packageMonitor = 'monitor';
export const smokeDetector = 'smokeFireDetector';
export const smokeDetectorWarningNote = 'smokeDetectorWarningNote';
export const easySmokeFireDetector = 'easySmokeFireDetector';
export const easyFiveYearSmokeFireDetector = 'easyFiveYearSmokeFireDetector';
export const easySmokeFireDetectorProtector = 'easySmokeFireDetectorProtector';
export const temperatureSensorFeeNote1 = 'temperatureSensorFeeNote1';
export const temperatureSensorFeeNote2 = 'temperatureSensorFeeNote2';
export const valueTariffed = 'Tariffed';
export const valueFivePercentDiscountOfferEN = '$5 Discount';
export const valueFivePercentDiscountOfferFR = '5$ de rabais';
export const valueQualifiedSpeed15mbps = '15/1 mbps';
export const valueQualifiedSpeed25mbps = '25/5 mbps';
export const valueQualifiedSpeed75mbps = '75/15 mbps';
export const valueQualifiedSpeed150mbps = '150/25 mbps';
export const valueQualifiedSpeed300mbps = '300/300 mbps';
export const valueQualifiedSpeed750mbps = '750/750 mbps';
export const valueQualifiedSpeed940mbps = '940/940 mbps';
export const valueQualifiedSpeed15gFibre = '1.5G/940 mbps';
export const valueQualifiedSpeed3gFibre = 'Fibre Internet 3G: 3G/3GMbps';
export const qualifiedSpeedOptions = {
  sixMBPSOrLess: ['15/1 mbps'],
  fifteenMBPS: ['15/1 mbps'],
  twentyFiveMBPS: ['15/1 mbps', '25/5 mbps'],
  fiftyMBPS: ['15/1 mbps', '25/5 mbps', '50 / 10 Mbps'],
  seventyFiveMBPS: ['15/1 mbps', '25/5 mbps', '75/15 mbps'],
  hundredMBPS: ['15/1 mbps', '25/5 mbps', '75/15 mbps', '100 / 20 Mbps'],
  oneFiftyMBPS: ['15/1 mbps', '25/5 mbps', '75/15 mbps', '150/25 mbps']
};
export const fieldManagerSpecialDiscount = 'fiberManagerSpecial';
export const fieldHighestQualifiedSpeed = 'highestQualifiedSpeed';
export const storedItemQualifiedSpeedOptions = 'storedQualifiedSpeedOptions';
export const fibre25GChannels = [
  'SBS_TI_SALES',
  'ISS_ONTARIO',
  'ISS_ALBERTA',
  'ISS_BRITISH_COLUMBIA'
];
export const fibre25GLocality = 'Calgary';
export const installationCalendarDateFormat = 'YYYY-MM-DD';
export const pagesNames = {
  REPORT_AN_ISSUE: 'reportAnIssue',
  HOW_TO_VIDEOS: 'howToVideos'
};
export const categoryFormKeys = {
  ORDER: 'ORDER',
  REFERRAL: 'REFERRAL',
  WIRELESS: 'WIRELESS',
  BRP: 'BRP',
  VULCAN: 'VULCAN',
  FM: 'FM'
};
export const categoryFormIds = {
  [categoryFormKeys.ORDER]: 1,
  [categoryFormKeys.REFERRAL]: 2,
  [categoryFormKeys.WIRELESS]: 3,
  [categoryFormKeys.BRP]: 4,
  [categoryFormKeys.VULCAN]: 6,
  [categoryFormKeys.FM]: 5
};
export const categoryFormNameMap = {
  'wireline and secure business': categoryFormKeys.ORDER,
  referrals: categoryFormKeys.REFERRAL,
  wireless: categoryFormKeys.WIRELESS,
  'brp webform': categoryFormKeys.BRP,
  vulcan: categoryFormKeys.VULCAN,
  'fully managed': categoryFormKeys.FM
};
export const formCategoryNames = {
  wirelineAndSecureBusinessForm: 'wireline and secure business',
  myOrderDashboard: 'My Order Dashboard',
  referrals: 'referrals',
  wireless: 'wireless',
  telusIOT: 'TELUS IOT',
  businessConnect: 'TELUS Business Connect Quote Tool/Order Form',
  businessConnectContactCentre:
    'TELUS Business Connect Contact Centre & Professional Services',
  phoneNumberPortalTool: 'Phone Number Portal Tool',
  brpForm: 'brp webform',
  vulForm: 'vulcan',
  fmForm: 'fully managed'
};
export const winbackPrefferedInstallationNoteProvinces = ['AB', 'BC'];
// export const fibre2_5G_PreferedInstallDate = '2021-09-01';
// export const fibre2_5G_SecondaryPreferedInstallDate = '2021-09-02';
// Not needed, unauthorized; Replaced the above to the below just changed name to 3G
export const fibre3G_PreferedInstallDate = '2021-09-01';
export const fibre3G_SecondaryPreferedInstallDate = '2021-09-02';
export const FibreInternet3GMbps = 'Fibre Internet 3G: 3G/3GMbps';

export const wlsOneTimeCategories = [
  'simTotal',
  'devicesTotal',
  'additionalCharges',
  'accessoriesTotal',
  'deviceSalesTax',
  'oneTimeTotal'
];

export const wlsRecurringCategories = [
  'ratePlanTotal',
  'easyPaymentTotal',
  'featuresTotal',
  'additionalFeaturesTotal',
  'monthlyTotal'
];

export const wirelessOrderDetailsSummaryOneTimeCategories = {
  simTotal: 'SIM',
  devicesTotal: 'Devices',
  additionalCharges: 'Additional charges (e.g. DEP)',
  accessoriesTotal: 'Accessories',
  deviceSalesTax: 'Taxes',
  oneTimeTotal: 'Total one-time costs'
};

export const wirelessOrderDetailsSummaryMonthlyCategories = {
  ratePlanTotal: 'Rate Plans',
  easyPaymentTotal: 'Easy Monthly Payment',
  featuresTotal: 'Features',
  additionalFeaturesTotal: 'Additional Features',
  monthlyTotal: 'Total monthly costs'
};

export const fieldSubscriberProvince = 'provinceWLS';
export const fieldSubscriberDetailsOfferCode = 'subscriberDetailsOfferCode';
export const fieldSubscriberDetailsValidationCode =
  'subscriberDetailsValidationCode';
export const fieldSubscriberDetailsContractTerm =
  'subscriberDetailsContractTerm';
export const fieldSubscriberDetailsDevicePlan = 'subscriberDetailsDevicePlan';
export const fieldSubscriberDetailsDevices = 'subscriberDetailsDevices';
export const fieldSubscriberDetailsColor = 'subscriberDetailsColor';
export const fieldSubscriberDetailsHardwareCredit =
  'subscriberDetailsHardwareCredit';
export const fieldSubscriberDetailsIsCpoDevice = 'subscriberDetailsIsCpoDevice';
export const fieldSubscriberDetailsCpoCategory = 'subscriberDetailsCpoCategory';
export const fieldSubscriberExtendedWarrantyProgram =
  'subscriberExtendedWarrantyProgram';
export const fieldSubscriberDetailsDeviceCare = 'subscriberDetailsDeviceCare';
export const fieldSubscriberDetailsTier = 'subscriberDetailsTier';
export const fieldSubscriberDetailsThreeYearTier =
  'subscriberDetailsThreeYearTier';
export const fieldSubscriberDetailsThreeYearHardwareCredits =
  'subscriberDetailsThreeYearHardwareCredits';
export const fieldSubscriberDetailsEsimSubmission =
  'subscriberDetailsEsimSubmission';
export const fieldSubscriberDetailsRateplanName =
  'subscriberDetailsRateplanName';
export const fieldSubscriberDetailsRateplanCost =
  'subscriberDetailsRateplanCost';
export const fieldSubscriberDetailsBalanceRepayment =
  'subscriberDetailsBalanceRepayment';
export const fieldSubscriberDetailsIsPreOrder = 'subscriberDetailsIsPreOrder';
export const fieldSubscriberDetailsIsGiftPurchase =
  'subscriberDetailsIsGiftPurchase';
export const fieldSubscriberDetailsGwpDetails = 'subscriberDetailsGwpDetails';
export const fieldSubscriberDetailsDeviceBalanceWaive =
  'subscriberDetailsDeviceBalanceWaive';
export const fieldSubscriberDetailsDeviceBalanceWaiveValue =
  'subscriberDetailsDeviceBalanceWaiveValue';
export const fieldSubscriberDetailsDeviceBalanceWaiveRemainingBalance =
  'subscriberDetailsDeviceBalanceWaiveRemainingBalance';
export const fieldSubscriberDetailsBibProgram = 'subscriberDetailsBibProgram';
export const fieldSubscriberDetailsBibCredit = 'subscriberDetailsBibCredit';
export const fieldSubscriberDetailsDeviceCredit =
  'subscriberDetailsDeviceCredit';
export const subscriberDetailsIsSimRequired = 'subscriberDetailsIsSimRequired';
export const subscriberDetailsIsSimRequiredDevicesAccessories =
  'subscriberDetailsIsSimRequiredDevicesAccessories';
export const fieldSubscriberDetailsDeviceEnrolmentProgram =
  'subscriberDetailsDeviceEnrolmentProgram';
export const fieldSubscriberDetailsAppleCustomerID =
  'subscriberDetailsAppleCustomerID';
export const fieldSubscriberDetailsSamsungCustomerID =
  'subscriberDetailsSamsungCustomerID';
export const subscriberDetailsDeviceEnrolmentProgram =
  'subscriberDetailsDeviceEnrolmentProgram';
export const fieldSubscriberDetailsSimRequiredReason =
  'subscriberDetailsSimRequiredReason';
export const fieldSubscriberDetailsTypeOfDevice =
  'subscriberDetailsTypeOfDevice';
export const fieldsimTypeByod = 'simTypeByod';
export const fieldsimType2Year = 'simType2Year';
export const fieldsimType3Year = 'simType3Year';
export const fieldDeviceType = 'deviceType';
export const fieldEid = 'eid'; // Refers to Apple Device Numbers (Embedded Identity Document)
export const fieldImei = 'imei'; // Refers to  Device identification number
export const valueEsim = 'Esim';
export const fieldsimTypeTablet = 'simTypeTablet';
export const fieldDeviceTypeTablet = 'deviceTypeTablet';
export const fieldEidTablet = 'eidTablet'; // Refers to Apple Device Numbers (Embedded Identity Document)
export const fieldImeiTablet = 'imeiTablet'; // Refers to  Device identification number

export const fieldSubscriberDetailsPromotions = 'subscriberDetailsPromotions';

export const appleIphoneSixteenDevicesWLS = [
  "Apple iPhone SE 64GB 2022",
  "Apple iPhone 14 128GB",
  "Apple iPhone 15 128GB",
  "Apple iPhone 15 Pro 256GB",
  "Apple iPhone 15 Pro Max 1TB",
  "Apple iPhone 15 Pro Max 1TB - Activation/Mise en Service",
  "Apple iPhone 15 Pro Max 1TB - Renewal/Renouvellement",
  "Apple iPhone 15 Pro Max 1TB/Mise en Service",
  "Apple iPhone 15 Pro Max 1TB BTL / Mise en service hors media",
  "Apple iPhone 16e 128GB",
  "Apple iPhone 16e 128GB - Feb 21 Pre-Order",
  "Apple iPhone 16 128GB",
  "Apple iPhone 16 128GB - Activation BTL / Mise en service hors media",
  "Apple iPhone 16 128GB - Renewal / Renouvellement",
  "Apple iPhone 16 128GB BTL / Mise en service hors media",
  "Apple iPhone 16 128GB - For Unlimited Rateplan, Activations Only",
  "Apple iPhone 16 128GB - For Sharepro Rateplan (Acts + Renewals) and Renewals on Unlimited Rateplan",
  "Apple iPhone 16 256GB",
  "Apple iPhone 16e 256GB",
  "Apple iPhone 16e 256GB - Feb 21 Pre-Order",
  "Apple iPhone 16 256GB - Activation BTL / Mise en service hors media",
  "Apple iPhone 16 256GB - Renewal / Renouvellement",
  "Apple iPhone 16 256GB BTL / Mise en service hors media",
  "Apple iPhone 16 256GB - For Unlimited Rateplan, Activations Only",
  "Apple iPhone 16 256GB - For Sharepro Rateplan (Acts + Renewals) and Renewals on Unlimited Rateplan",
  "Apple iPhone 16 Plus 128GB",
  "Apple iPhone 16 Plus 128GB - Activation BTL / Mise en service hors media",
  "Apple iPhone 16 Plus 128GB - Renewal / Renouvellement",
  "Apple iPhone 16 Plus 128GB BTL / Mise en service hors media",
  "Apple iPhone 16 Plus 128GB - For Unlimited Rateplan, Activations Only",
  "Apple iPhone 16 Plus 128GB - For Sharepro Rateplan (Acts + Renewals) and Renewals on Unlimited Rateplan",
  "Apple iPhone 16 Plus 256GB",
  "Apple iPhone 16 Plus 256GB - Activation BTL / Mise en service hors media",
  "Apple iPhone 16 Plus 256GB - Renewal / Renouvellement",
  "Apple iPhone 16 Plus 256GB BTL / Mise en service hors media",
  "Apple iPhone 16 Plus 256GB - For Unlimited Rateplan, Activations Only",
  "Apple iPhone 16 Plus 256GB - For Sharepro Rateplan (Acts + Renewals) and Renewals on Unlimited Rateplan",
  "Apple iPhone 16e 512GB",
  "Apple iPhone 16e 512GB - Feb 21 Pre-Order",
  "Apple iPhone 16 Plus 512GB",
  "Apple iPhone 16 Plus 512GB - Activation BTL / Mise en service hors media",
  "Apple iPhone 16 Plus 512GB - Renewal / Renouvellement",
  "Apple iPhone 16 Plus 512GB BTL / Mise en service hors media",
  "Apple iPhone 16 Plus 512GB - For Unlimited Rateplan, Activations Only",
  "Apple iPhone 16 Plus 512GB - For Sharepro Rateplan (Acts + Renewals) and Renewals on Unlimited Rateplan",
  "Apple iPhone 16 Pro 128GB",
  "Apple iPhone 16 Pro 128GB - Activation BTL / Mise en service hors media",
  "Apple iPhone 16 Pro 128GB - Renewal / Renouvellement",
  "Apple iPhone 16 Pro 128GB BTL / Mise en service hors media",
  "Apple iPhone 16 Pro 128GB - For Unlimited Rateplan, Activations Only",
  "Apple iPhone 16 Pro 128GB - For Sharepro Rateplan (Acts + Renewals) and Renewals on Unlimited Rateplan",
  "Apple iPhone 16 Pro 256GB",
  "Apple iPhone 16 Pro 256GB - Activation BTL / Mise en service hors media",
  "Apple iPhone 16 Pro 256GB - Renewal / Renouvellement",
  "Apple iPhone 16 Pro 256GB BTL / Mise en service hors media",
  "Apple iPhone 16 Pro 256GB - For Unlimited Rateplan, Activations Only",
  "Apple iPhone 16 Pro 256GB - For Sharepro Rateplan (Acts + Renewals) and Renewals on Unlimited Rateplan",
  "Apple iPhone 16 Pro 512GB",
  "Apple iPhone 16 Pro 512GB - Activation BTL / Mise en service hors media",
  "Apple iPhone 16 Pro 512GB - Renewal / Renouvellement",
  "Apple iPhone 16 Pro 512GB BTL / Mise en service hors media",
  "Apple iPhone 16 Pro 512GB - For Unlimited Rateplan, Activations Only",
  "Apple iPhone 16 Pro 512GB - For Sharepro Rateplan (Acts + Renewals) and Renewals on Unlimited Rateplan",
  "Apple iPhone 16 Pro Max 1TB",
  "Apple iPhone 16 Pro Max 1TB - Activation BTL / Mise en service hors media",
  "Apple iPhone 16 Pro Max 1TB - Renewal / Renouvellement",
  "Apple iPhone 16 Pro Max 1TB BTL / Mise en service hors media",
  "Apple iPhone 16 Pro Max 1TB - For Unlimited Rateplan, Activations Only",
  "Apple iPhone 16 Pro Max 1TB - For Sharepro Rateplan (Acts + Renewals) and Renewals on Unlimited Rateplan",
  "Apple iPhone 16 Pro Max 256GB",
  "Apple iPhone 16 Pro Max 256GB - Activation BTL / Mise en service hors media",
  "Apple iPhone 16 Pro Max 256GB - Renewal / Renouvellement",
  "Apple iPhone 16 Pro Max 256GB BTL / Mise en service hors media",
  "Apple iPhone 16 Pro Max 256GB - For Unlimited Rateplan, Activations Only",
  "Apple iPhone 16 Pro Max 256GB - For Sharepro Rateplan (Acts + Renewals) and Renewals on Unlimited Rateplan",
  "Apple iPhone 16 Pro Max 512GB",
  "Apple iPhone 16 Pro Max 512GB - Activation BTL / Mise en service hors media",
  "Apple iPhone 16 Pro Max 512GB - Renewal / Renouvellement",
  "Apple iPhone 16 Pro Max 512GB BTL / Mise en service hors media",
  "Apple iPhone 16 Pro Max 512GB - For Unlimited Rateplan, Activations Only",
  "Apple iPhone 16 Pro Max 512GB - For Sharepro Rateplan (Acts + Renewals) and Renewals on Unlimited Rateplan"
];

export const reasonForSubmission = 'reasonForSubmission';
export const reasonForSubOptionsEN = [
  'MSS Issue',
  'MSS order requiring resubmission',
  'Order is NOT eligible for MSS',
  'Expired Offer/Promo'
];
export const reasonForSubOptionsFR = [
  'Problème dans le SVSM',
  'Commandes dans le SVSM qui doivent être soumises de nouveau',
  'Commande NON admissible au SVSM',
  'Offre promotionnelle expirée'
];
export const fieldIssueSummary = 'issueSummary';
export const fieldExpectedBehavior = 'expectedBehaviour';
export const fieldCurrentBehaviour = 'currentBehaviour';
export const fieldOriginalMssOrderNumber = 'originalMssOrderNumber';

export const fieldPromoNameThatExpired = 'promoNameThatExpired';
export const fieldDatePromoExpired = 'datePromoExpired';
export const fieldScreenshotOfSavedOrderInMSS = 'screenshotOfSavedOrderInMSS';
export const files = 'files';

export const leadSourceCompany = 'leadSourceCompany';
export const bcxSMBOnline = ['bcx', 'smb', 'smbOnlineOrder'];
export const mms = ['mmmms'];
export const indirectPartners = ['indirectPartners'];
export const sourceOfSaleWLS = 'sourceOfSaleWLS';
export const smbOnlineOrder = 'SMB Online Order';
export const inkerosEastWestChannels = [`INKEROS_EAST`, `INKEROS_WEST`];
export const albertaAndBritish = ['alberta', 'british_columbia'];
export const leadSourceCompanyList = [
  'Inkeros East',
  'Inkeros West',
  'LTS',
  'LNR',
  'TAG Copper',
  'ÉTIQUETTE Cuivre',
  'TAG Falcon',
  // Bottom list is the French version
  'Inkeros East',
  'Inkeros Ouest',
  'LTS',
  'LNR',
  'ÉTIQUETTE Cuivre',
  'TAG Falcon'
];
export const hardwarePaidAlready = 'hardwarePaidAlready';
export const omsParentOrderNumber = 'omsParentOrderNumber';
export const orderNotEligibleforMssReason = 'orderNotEligibleforMssReason';
export const mssDefectTeam = 'mssDefectTeam';
export const spocTicketNumber = 'spocTicketNumber';
export const channelTicketNumber = 'channelTicketNumber';
export const BCX_CARE = 'BCX Care';
export const SMB_Sales = 'SMB Sales';
export const sevenX = '7X';
export const devicesOnly = 'Devices only';
export const devicesOnlyProductSelection = ['Wireless', 'Services mobiles'];
export const requiresDirectorsApproval = 'requiresDirectorsApproval';
export const directorsName = 'directorsName';
export const directorsEmail = 'directorsEmail';
export const billingAddress = 'Billing Address';
export const accountType = 'accountType';
export const deviceProtection = 'Device Protection';
export const deviceProtectionFrench = "Protection de l'appareil";
export const mediumCompanies = ['BSW', 'BSE'];
export const businessRegularMedium = 'businessRegularMedium';
export const regularCompanies = [
  'Inkeros East',
  'Inkeros West',
  'LTS',
  'LNR',
  'Procom',
  'Procom - D2D Hunters',
  'TAG Copper',
  'TAG Falcon',
  'TELUS International',
  'Direct Sales',
  'ISS',
  'ISS TQ',
  'ADT',
  // Bottom list is the French version
  'Inkeros East',
  'Inkeros Ouest',
  'LTS',
  'LNR',
  'Procom',
  'Procom - Chasseurs D2D',
  'ÉTIQUETTE Cuivre',
  'TAG Falcon',
  'TELUS International',
  'Les ventes directes',
  'ISS',
  'ISS TQ',
  'ADT'
];
export const businessPersonal = 'businessPersonal';
export const businessRegular = 'businessRegular';
export const activationType = 'activationType';
export const activationTypeListOne = [
  'Customer Facing Activation',
  'Mise en service client',
  'Telesales Activation',
  'Mise en service télévente'
];
export const activationTypeListTwo = [
  'SMB Online Renewal',
  'Renouvellement en ligne : Solutions aux PME'
];
export const addOnActivationTypeListForLNR = [
  'Telesales Activation',
  'Mise en service télévente'
];
export const renewalActivationTypeListForLNR = [
  'Telesales Activation or Renewal',
  'Mise en service télévente ou Renouvellement'
];
export const activationTypeListThree = [
  'Customer Facing Activation or Renewal',
  'Mise en service client ou Renouvellement',
  'Telesales Activation or Renewal',
  'Mise en service télévente ou Renouvellement',
  'SMB Online Renewal',
  'Renouvellement en ligne : Solutions aux PME'
];
export const addOnActivation = [
  'Add-on Activation',
  'Ajout à un compte existant'
];
export const customerLocation = 'customerLocation';
export const newWirelessActivation = [
  'New Wireless Activation',
  'Nouvelle commande de services sans fil'
];
export const customerFacingActivation = [
  'Customer Facing Activation',
  'Mise en service client'
];
export const productSelectionWLS = 'productSelectionWLS';
export const wireless = ['Wireless', 'Services mobiles'];
export const renewal = ['Renewal', 'Renouvellement'];
export const numberOfSubscribers = 'numberOfSubscribers';
export const isThisHealth = 'isThisHealth';
export const activationTypeIncludesList = [
  'serviceOrShippingAddress',
  'billingAddress'
];
export const activationTypeNotIncludesList = ['billingOrShippingAddress'];
export const telesalesActivation = [
  'Telesales Activation',
  'Mise en service télévente'
];
export const agentNameSalesRep = 'agentNameSalesRep';
export const agentEmailAddress = 'agentEmailAddress';
export const outletSalesRep = 'outletSalesRep';
export const idSalesRep = 'idSalesRep';
export const contactNumberSalesRep = 'contactNumberSalesRep';
export const tIDxIDSalesRep = 'tIDxIDSalesRep';
export const channelSalesRep = 'channelSalesRep';
export const channelNameSalesRep = 'channelNameSalesRep';
export const smbIndirectChannelSalesRep = 'smbIndirectChannelSalesRep';
export const channelManagerSalesRep = 'channelManagerSalesRep';
export const channelManagerEmailAddress = 'channelManagerEmailAddress';
export const telusAccountNumberCustomerInformation =
  'telusAccountNumberCustomerInformation';
export const tradeNameWLS = 'tradeNameWLS';
export const accountNumberWLS = 'accountNumberWLS';
export const addOnAndRenewal = [
  'Add-on Activation',
  'Ajout à un compte existant',
  'Renewal',
  'Renouvellement'
];
export const creditCheckPassMSS = 'creditCheckPassMSS';
export const addOnAndNewWireless = [
  'Add-on Activation',
  'Ajout à un compte existant',
  'New Wireless Activation',
  'Nouvelle commande de services sans fil'
];
export const telusAccountNumberMSS = 'telusAccountNumberMSS';
export const leadSourceCompanyMSSList = [
  'Inkeros East',
  'Inkeros East',
  'Inkeros West',
  'Inkeros Ouest',
  'ADT',
  'ADT'
];
export const Yes = 'Yes';
export const caratID = 'caratID';
export const No = 'No';
export const sFDCRCIDNumber = 'sFDCRCIDNumber';
export const isCustomerOwner = 'isCustomerOwner';
export const website = 'website';
export const addAuthorisedContact = 'addAuthorisedContact';
export const fullNameWLS = 'fullName';
export const pinCode = 'pinCode';
export const signupForEBill = 'signupForEBill';
export const smsNumber = 'smsNumber';
export const visitedShippingAddress = 'visitedShippingAddress';
export const fieldWirlessConfirmationCustomer = 'wirlessConfirmationCustomer';
export const fieldActivationLanguage = 'activationLanguage';
export const fieldInstallationTypeWLS = 'installationTypeWLS';
export const fieldRemediationPaymentPlanTerm = 'remediationPaymentPlanTerm';
export const fieldFullyManagedTerm = 'Term';
export const fieldRemediationOneTimeCharge = 'remediationOneTimeCharge';
export const fieldRemediationMonthlyCharge = 'remediationMonthlyCharge';
export const fieldRemediationProjectValue = 'remediationProjectValue';
export const fieldRemediationProject = 'remediationProject';
export const additionalCommentsNote = 'additionalCommentsNote';
export const wlsBusinessLegalName = 'wlsBusinessLegalName';
export const subscriberDetailsWillPhoneNumberBePortedIn =
  'subscriberDetailsWillPhoneNumberBePortedIn';
export const subscriberDetailsPhoneNumberRenewal =
  'subscriberDetailsPhoneNumberRenewal';
export const subscriberDetailsAccessoryFinanced =
  'subscriberDetailsAccessoryFinanced';
export const subscriberExtendedWarrantyProgramBYOD =
  'subscriberExtendedWarrantyProgramBYOD';
export const subscriberDetailsDeviceCareBYOD =
  'subscriberDetailsDeviceCareBYOD';
export const subscriberDetailsContractTerm = 'subscriberDetailsContractTerm';
export const subscriberDetailsDeviceModel = 'subscriberDetailsDeviceModel';
export const subscriberDetailsEasyPaymentAmount =
  'subscriberDetailsEasyPaymentAmount';
export const subscriberDetailsUpfrontCost = 'subscriberDetailsUpfrontCost';
export const subscriberDetailsTaxes = 'subscriberDetailsTaxes';
export const contractTermBYOD = ['BYOD', 'AVPA'];
export const contractTerm2Year = '2 Year';
export const contractTerm3Year = ['3 Year', '3 Ans'];
export const deviceCareComplete = 'Device Care Complete ($17.00)';
export const deviceCareCompleteAlberta = 'Device Care Complete (Alberta) $16.50';
export const appleCareTier5 =
  'Apple Care+ Tier 5 ($17.00) (iPhones X, XS, XS Max, 11 Pro, 11 Pro Max, 12 Pro, 12 Pro Max, 13 Pro, 13 Pro Max, 15 Pro, 15 Pro Max, 14 Pro, 14 Pro Max)';
export const appleCareTier4A =
  'Apple Care+ Tier 4A ($16.00) (iPhones 15 Plus and iPhone 14 Plus)';
export const appleCareTier4 =
  'Apple Care+ Tier 4 ($14.00) (iPhones 15, 14, 13, 13 Mini, 12, 12 Mini, 11, XR, 8 Plus, 7 Plus, 6S Plus, 6 Plus)';
export const appleCarePlus12 = 'Apple Care+ ($12.00) (iPhones 8,7, 6S and 6)';
export const appleCarePlus9 =
  'Apple Care+ ($9.00) (iPhone SE 2nd and 3rd Generation)';
export const contractTermOwnerAdvantagePlan = 'Owner’s Advantage Plan';
export const contractTermDevicePurchaseMTM = 'Device Purchase + MTM';
export const devicePlanCategoryUnlimitedForBusiness =
  "Unlimited for Business/Owner's advantage";
export const subscriberDetailsFirstName = 'subscriberDetailsFirstName';
export const subscriberDetailsLastName = 'subscriberDetailsLastName';
export const subscriberDetailsPhoneNumber = 'subscriberDetailsPhoneNumber';
export const subscriberDetailsServiceProvider =
  'subscriberDetailsServiceProvider';
export const subscriberDetailsAccountNumber = 'subscriberDetailsAccountNumber';
export const subscriberDetailsPortInCredit = 'subscriberDetailsPortInCredit';
export const subscriberDetailsLocalCity = 'subscriberDetailsLocalCity';
export const fieldSubscriberDetailsSpecialInstructions =
  'subscriberDetailsSpecialInstructions';
export const DevicesOnlyEnglish = 'Devices only';
export const DevicesOnlyFrench = 'Appareils';
export const AccessoriesOnlyEnglish = 'Accessories only';
export const SmbOnlineEnglish = 'SMB Online Order';
export const SmbOnlineFrench = 'Commande en ligne de Solutions aux PME';
export const AccessoriesOnlyFrench = 'Accessoires';
export const accessoryCategoryKeys = [
  'cases',
  'screenProtection',
  'charging',
  'audio'
];
export const accessoryValues = {
  id: '#',
  Category: 'Category',
  Product: 'Product',
  SKU: 'SKU',
  Price: 'Price (without taxes)',
  Tax: 'Sales Tax',
  Remove: 'Remove'
};
export const fieldSubscriberDetailsExistingPhoneNumber =
  'subscriberDetailsExistingPhoneNumber';
export const specialOffers = 'Special Offers';

export const englishContractTermValues = [
  `BYOD`,
  `2 Year`,
  `3 Year`,
  `Owner’s Advantage Plan`,
  `Device Purchase + MTM`
];

export const frenchContractTermValues = [
  `AVPA`,
  `2 Ans`,
  `3 Ans`,
  `Forfait Avantage du Propriétaire`,
  `Achat d'Appareil + Entente sur une base mensuelle`
];

export const englishDevicePlanCategoryValues = [
  `BYOD Smartphone`,
  `BYOD MTM Tablet`,
  `BYOD MTM Watch`,
  `BYOD MTM TELUS Drive+`,
  `Voice Only`,
  `Tablet`,
  `Watch`,
  `Mobile High Speed/SmartHub`,
  `Unlimited for Business/Owner's advantage`,
  `Smartphone`
];

export const frenchDevicePlanCategoryValues = [
  `AVPA Téléphone intelligent (mensuel)`,
  `AVPA Tablette (mensuel)`,
  `AVPA Montre (mensuel)`,
  `AVPA Voiture+ (mensuel)`,
  `Appels seulement`,
  `Tablette`,
  `Montre`,
  `Haute vitesse mobile/Terminal intelligent`,
  `Illimité Affaires/Forfait Avantage du Propriétaire`,
  `Téléphone intelligent`
];

export const devicePlanKeyMap = {
  "Unlimited for Business/Owner's advantage": 'Unlimited for Business'
};

export const englishTierValues = [
  `Low Up Front`,
  `Zero Up Front`,
  `Low Monthly`,
  `Zero Upfront`
];

export const frenchTierValues = [
  `Acompte réduit`,
  `Aucun acompte`,
  `Mensualités réduites`,
  `Aucun acompte`
];

export const englishCPOCategoryValues = [`Like-New`,`Good`,`Very Good`];

export const frenchCPOCategoryValues = [`Comme neuf`,`Bon`,`Très bon` ,];

export const englishProvinceValues = [
  `alberta`,
  `british_columbia`,
  `manitoba`,
  `newBrunswick`,
  `newfoundlandAndLabrador`,
  `nunavut`,
  `novaScotia`,
  `northwestTerritories`,
  `ontario`,
  `princeEdwardIsland`,
  `quebec`,
  `saskatchewan`,
  `yukon`
];

export const frenchProvinceValues = [
  `Alberta`,
  `Colombie britannique`,
  `Manitoba`,
  `Nouveau-Brunswick`,
  `Terre-Neuve-et-Labrador`,
  `Nunavut`,
  `Nouvelle-Écosse`,
  `Territoires du nord-ouest`,
  `Ontario`,
  `Prince Edward Island`,
  `Quebec`,
  `Saskatchewan`,
  `Yukom`
];

export const provincesTaxPercentageMap = {
  alberta: 5,
  Alberta: 5,
  british_columbia: 12,
  'Colombie britannique': 12,
  manitoba: 12,
  Manitoba: 12,
  newBrunswick: 15,
  'Nouveau-Brunswick': 15,
  newfoundlandAndLabrador: 15,
  'Terre-Neuve-et-Labrador': 15,
  nunavut: 5,
  Nunavut: 5,
  novaScotia: 15,
  'Nouvelle-Écosse': 15,
  northwestTerritories: 5,
  'Territoires du nord-ouest': 5,
  ontario: 13,
  Ontario: 13,
  princeEdwardIsland: 15,
  'Prince Edward Island': 15,
  quebec: 14.975,
  Quebec: 14.975,
  saskatchewan: 11,
  Saskatchewan: 11,
  yukon: 5,
  Yukon: 5
};

export const canadianProvinceTaxKeysDevicesThreeYear = {
  alberta: {
    LMEP: 'LMEP_tax_per_ab_terr',
    LUEP: 'LUEP_tax_per_ab_terr',
    ZUEP: 'ZUEP_tax_per_ab_terr'
  },
  british_columbia: {
    LMEP: 'LMEP_tax_per_bc',
    LUEP: 'LUEP_tax_per_bc',
    ZUEP: 'ZUEP_tax_per_bc'
  },
  manitoba: {
    LMEP: 'LMEP_tax_per_mb',
    LUEP: 'LUEP_tax_per_mb',
    ZUEP: 'ZUEP_tax_per_mb'
  },
  newBrunswick: {
    LMEP: 'LMEP_tax_per_nb_ns_pei_nfl',
    LUEP: 'LUEP_tax_per_nb_ns_pei_nfl',
    ZUEP: 'ZUEP_tax_per_nb_ns_pei_nfl'
  },
  newfoundlandAndLabrador: {
    LMEP: 'LMEP_tax_per_nb_ns_pei_nfl',
    LUEP: 'LUEP_tax_per_nb_ns_pei_nfl',
    ZUEP: 'ZUEP_tax_per_nb_ns_pei_nfl'
  },
  northwestTerritories: {
    LMEP: 'LMEP_tax_per_ab_trr',
    LUEP: 'LUEP_tax_per_ab_trr',
    ZUEP: 'ZUEP_tax_per_ab_terr'
  },
  nunavut: {
    LMEP: 'LMEP_Taxes',
    LUEP: 'LUEP_Taxes',
    ZUEP: 'ZUEP_tax_per_ab_terr'
  },
  ontario: {
    LMEP: 'LMEP_tax_per_on',
    LUEP: 'LUEP_tax_per_on',
    ZUEP: 'ZUEP_tax_per_on'
  },
  princeEdwardIsland: {
    LMEP: 'LMEP_tax_per_nb_ns_pei_nfl',
    LUEP: 'LUEP_tax_per_nb_ns_pei_nfl',
    ZUEP: 'ZUEP_tax_per_nb_ns_pei_nfl'
  },
  quebec: {
    LMEP: 'LMEP_Taxes',
    LUEP: 'LUEP_Taxes',
    ZUEP: 'ZUEP_tax_per_qc'
  },
  saskatchewan: {
    LMEP: 'LMEP_tax_per_sk',
    LUEP: 'LUEP_tax_per_sk',
    ZUEP: 'ZUEP_tax_per_sk'
  },
  yukon: {
    LMEP: 'LMEP_Taxes',
    LUEP: 'LUEP_Taxes',
    ZUEP: 'ZUEP_tax_per_ab_terr'
  },
  novaScotia: {
    LMEP: 'LMEP_tax_per_nb_ns_pei_nfl',
    LUEP: 'LUEP_tax_per_nb_ns_pei_nfl',
    ZUEP: 'ZUEP_tax_per_nb_ns_pei_nfl'
  }
};
export const canadianProvinceTaxKeysDevices = {
  alberta: {
    LMEP: 'lmep_tax_per_ab_trr',
    LUEP: 'LUEP_tax_per_ab_trr',
    ZUEP: 'zuep_tax_per_ab_terr'
  },
  british_columbia: {
    LMEP: 'lmep_tax_per_bc',
    LUEP: 'LUEP_tax_per_bc',
    ZUEP: 'zuep_tax_per_bc'
  },
  manitoba: {
    LMEP: 'lmep_tax_per_mb',
    LUEP: 'LUEP_tax_per_mb',
    ZUEP: 'zuep_tax_per_mb'
  },
  newBrunswick: {
    LMEP: 'lmep_tax_per_nb_ns_pei_nfl',
    LUEP: 'LUEP_tax_per_nb_ns_pei_nfl',
    ZUEP: 'zuep_tax_per_nb_ns_pei_nfl'
  },
  newfoundlandAndLabrador: {
    LMEP: 'lmep_tax_per_nb_ns_pei_nfl',
    LUEP: 'LUEP_tax_per_nb_ns_pei_nfl',
    ZUEP: 'zuep_tax_per_nb_ns_pei_nfl'
  },
  northwestTerritories: {
    LMEP: 'lmep_tax_per_ab_trr',
    LUEP: 'LUEP_tax_per_ab_trr',
    ZUEP: 'zuep_tax_per_ab_terr'
  },
  nunavut: {
    LMEP: 'LMEP_Taxes',
    LUEP: 'LUEP_Taxes',
    ZUEP: 'zuep_tax_per_ab_terr'
  },
  ontario: {
    LMEP: 'lmep_tax_per_on',
    LUEP: 'LUEP_tax_per_on',
    ZUEP: 'zuep_tax_per_on'
  },
  princeEdwardIsland: {
    LMEP: 'lmep_tax_per_nb_ns_pei_nfl',
    LUEP: 'LUEP_tax_per_nb_ns_pei_nfl',
    ZUEP: 'zuep_tax_per_nb_ns_pei_nfl'
  },
  quebec: {
    LMEP: 'LMEP_Taxes',
    LUEP: 'LUEP_Taxes',
    ZUEP: 'zuep_tax_per_qc'
  },
  saskatchewan: {
    LMEP: 'lmep_tax_per_sk',
    LUEP: 'LUEP_tax_per_sk',
    ZUEP: 'zuep_tax_per_sk'
  },
  yukon: {
    LMEP: 'LMEP_Taxes',
    LUEP: 'LUEP_Taxes',
    ZUEP: 'zuep_tax_per_ab_terr'
  },
  novaScotia: {
    LMEP: 'lmep_tax_per_nb_ns_pei_nfl',
    LUEP: 'LUEP_tax_per_nb_ns_pei_nfl',
    ZUEP: 'zuep_tax_per_nb_ns_pei_nfl'
  }
};

export const canadianProvinceTaxKeys = {
  alberta: {
    LMEP: 'lmep_tax_per_ab_trr',
    LUEP: 'LUEP_tax_per_ab_trr',
    ZUEP: 'ZUEP_tax_per_ab_trr'
  },
  british_columbia: {
    LMEP: 'lmep_tax_per_bc',
    LUEP: 'LUEP_tax_per_bc',
    ZUEP: 'ZUEP_tax_per_bc'
  },
  manitoba: {
    LMEP: 'lmep_tax_per_mb',
    LUEP: 'LUEP_tax_per_mb',
    ZUEP: 'ZUEP_tax_per_mb'
  },
  newBrunswick: {
    LMEP: 'lmep_tax_per_nb_ns_pei_nfl',
    LUEP: 'LUEP_tax_per_nb_ns_pei_nfl',
    ZUEP: 'ZUEP_tax_per_nb_ns_pei_nfl'
  },
  newfoundlandAndLabrador: {
    LMEP: 'lmep_tax_per_nb_ns_pei_nfl',
    LUEP: 'LUEP_tax_per_nb_ns_pei_nfl',
    ZUEP: 'ZUEP_tax_per_nb_ns_pei_nfl'
  },
  northwestTerritories: {
    LMEP: 'lmep_tax_per_ab_trr',
    LUEP: 'LUEP_tax_per_ab_trr',
    ZUEP: 'ZUEP_tax_per_ab_trr'
  },
  nunavut: {
    LMEP: 'LMEP_Taxes',
    LUEP: 'LUEP_Taxes',
    ZUEP: 'ZUEP_Taxes'
  },
  ontario: {
    LMEP: 'lmep_tax_per_on',
    LUEP: 'LUEP_tax_per_on',
    ZUEP: 'ZUEP_tax_per_on'
  },
  princeEdwardIsland: {
    LMEP: 'lmep_tax_per_nb_ns_pei_nfl',
    LUEP: 'LUEP_tax_per_nb_ns_pei_nfl',
    ZUEP: 'ZUEP_tax_per_nb_ns_pei_nfl'
  },
  quebec: {
    LMEP: 'LMEP_Taxes',
    LUEP: 'LUEP_Taxes',
    ZUEP: 'ZUEP_Taxes'
  },
  saskatchewan: {
    LMEP: 'lmep_tax_per_sk',
    LUEP: 'LUEP_tax_per_sk',
    ZUEP: 'ZUEP_tax_per_sk'
  },
  yukon: {
    LMEP: 'LMEP_Taxes',
    LUEP: 'LUEP_Taxes',
    ZUEP: 'ZUEP_Taxes'
  },
  novaScotia: {
    LMEP: 'lmep_tax_per_nb_ns_pei_nfl',
    LUEP: 'LUEP_tax_per_nb_ns_pei_nfl',
    ZUEP: 'ZUEP_tax_per_nb_ns_pei_nfl'
  }
};

export const channelOutletMapping = {
  'SMB A 1 to 30 1A': ['1100052600'],
  'SMB Growth Sales W 2B': ['1100052601'],
  'SMB Retention 1 to 30 1C': ['1100052602'],
  'SMB Retention 1 to 30 1D': ['1100052603'],
  'SMB Retention 30 to 100 2A': ['1100052604'],
  'SMB A 1 to 30 1C': ['1100052605'],
  'SMB Retention Sales 30 to 100 2D': ['1100052606'],
  'SMB Retention 30 to 100 2D': ['1100052607'],
  'SMB Growth Sales W 1A': ['1100052608'],
  'SMB Growth Sales W 1B': ['1100052609'],
  'SMB Growth Sales W 1C': ['1100052610'],
  'SMB Growth Sales W 1D': ['1100052611'],
  'SMB Growth Sales W 2A': ['1100052612'],
  'SMB Growth Sales W 2C': ['1100052614'],
  'SMB Growth Sales W 2D': ['1100052615'],
  'SMB Growth Sales E 1A': ['1100052616'],
  'SMB Growth Sales E 2B': ['1100052617'],
  'SMB Growth Sales E 3C': ['1100052618'],
  'SMB Growth Sales E 1D': ['1100052619'],
  'SMB Growth Sales E 3E': ['1100052620'],
  'SMB Growth Sales E 2A': ['1100052621'],
  'SMB Growth Sales E 3A': ['1100052622'],
  'SMB Growth Sales E 2C': ['1100052623'],
  'SMB A 1 to 30 1B': ['1100052624'],
  'SMB Growth Sales E 3D': ['1100052625'],
  'SMB Growth Sales E 1B': ['1100052626'],
  'SMB Growth Sales E 3B': ['1100052627'],
  'SMB Growth Sales E 2D': ['1100052628'],
  'SMB Growth Sales E 1C': ['1100052629'],
  'SMB Growth Sales E 4A': ['1100052630'],
  'SMB Growth Sales E 4B': ['1100052631'],
  'SMB Growth Sales E 4C': ['1100052632'],
  'SMB Growth Sales E 4D': ['1100053088'],
  'SMB Growth Sales E 4E': ['1100052634'],
  'SMB Growth Sales 30 to 100 1A': ['1100052635'],
  'SMB Growth Sales 30 to 100 1B': ['1100052636'],
  'SMB Growth Sales 30 to 100 1D': ['1100052638'],
  'SMB Growth Sales 30 to 100 2A': ['1100052639'],
  'SMB Growth Sales 30 to 100 1C': ['1100052640'],
  'SMB Growth Sales 30 to 100 2C': ['1100052641'],
  'SMB L&R 1': ['1100052642'],
  'SMB L&R 2': ['1100052643'],
  'SMB L&R 3': ['1100052644'],
  'SMB L&R 4': ['1100052645'],
  'SMB L&R 5': ['1100052646'],
  'SMB L&R TI': ['1100052647'],
  'SMB Indirect Sales - Other': ['1100052561'],
  'SMB Indirect Sales - TAG': ['1100052562'],
  'SMB Indirect Sales - Elite Promotions': ['1100052563'],
  'SMB New Growth Market 1': ['1100050829'],
  'SMB New Growth Market 2': ['1100052073'],
  'SMB Indirect Sales- CORPO SOLUTION': ['1100052725'],
  'SMB Indirect Sales- CBTELECOM': ['1100052726'],
  'SMB Indirect Sales- IDS': ['1100052727'],
  'SMB Indirect Sales- MSG CONSULTING': ['1100052728'],
  'SMB Indirect Sales- CONNEXION FK': ['1100052729'],
  'SMB Indirect Sales- REVOLVE': ['1100052730'],
  'SMB Indirect Sales- GET INSTINCTIVE': ['1100052731'],
  'SMB Indirect Sales- TOPS TECH': ['1100052732'],
  'SMB Indirect Sales- OUTPUT': ['1100052733'],
  'SMB Indirect Sales- ATMOS MANAGEMENT': ['1100052734'],
  'SMB Indirect Sales- KOLLABB': ['1100052735'],
  'SMB Indirect Sales- UP SYSTEMS': ['1100052736'],
  'SMB Indirect Sales- WATCHDOG': ['1100052737'],
  'SMB Growth Sales 30 to 100 3B': ['1100052968'],
  'SMB Growth Sales Advance QC': ['1100052976'],
  'SMB Growth Sales Advance ON': ['1100053184'],
  'TAG BC': ['1100053076'],
  'TAG AB': ['1100053077'],
  'Elite Promotions & Marketing Inc.': ['1100053078'],
  'EVOLUTION CLOUD INC': ['1100053079'],
  '7X': ['1100053080'],
  'Tech23 Solutions Inc.': ['1100053081'],
  'Output Inc.': ['1100053082'],
  'SMB New Growth Market 3': ['1100052952'],
  'SMB New Growth Market 4': ['1100053235'],
  'SMB Growth Sales 30 to 100 3A': ['1100053244'],
  'SMB Growth Sales 30 to 100 3C': ['1100052637'],
  'SMB Growth Sales E 2E': ['1100052970'],
  'SMB Growth Sales Advance BDR': ['9900000019'],
  'SMB Growth Sales 30 to 100 2B': ['1100054078'],
  'SMB Growth Sales Advance WEST': ['1100054079'],
  'SMB Growth Sales Fully Managed': ['1100054080'],
  'SMB A 1 to 30 1E': ['1100053219'],
  // 'White Glove NBD Technicians': ['1000013457'],
  NGM: ['1000013457'],
  'SMB L&R TI 2': ['1100052977'],
  'SMB L&R TI 3': ['1100053942'],
  'SMB TI Sales Digital': ['1100049353'],
  'SMB TI Sales Base Management': ['1100050925'],
  'SMB TI ADT Retention': ['1100054211'],
  'SMB TI Digital - EN': ['1100054212'],
  'SMB TI Digital - FR': ['1100054213'],
  'SMB TI HSIA Growth': ['1100054214'],
  'SMB TI NBS Value Add': ['1100054215'],
  'SMB TI WLN Retention': ['1100054216'],
  'SMB TI WLS Growth QC': ['1100054217'],
  'SMB TI WLS Growth ROC': ['1100054218'],
  'SBS Telesales TI': ['Not Provided'], // for this channel outlet id is not provided
  PiiComm: ['9900000020'],
  'SMB Growth Sales CBS': ['1100054384'],
  'SMB RFS 1': ['1100054964'],
  'SMB RFS 2': ['1100054965'],
  'SMB TI Growth National': ['1100054405'],
  'SMB Growth Sales Fully Managed B' : ['1100054505']
};

export const sof1HomeUrl = 'https://www.mysofportal.com';
export const sof2HomeUrl = 'https://www.mysalesorders.com';
export const adtHomeUrl = 'https://www.myorderdashboard.com';

export const fieldBrpAvailibility = 'brpAvailibility';
export const fieldBrpProductToBook = 'brpProductToBook';
export const fieldBrpServiceAddressStreetNumber =
  'brpServiceAddressStreetNumber';
export const fieldBrpServiceAddressStreetName = 'brpServiceAddressStreetName';
export const fieldBrpServiceAddressUnitNumber = 'brpServiceAddressUnitNumber';
export const fieldBrpServiceAddressCity = 'brpServiceAddressCity';
export const fieldBrpServiceAddressProvince = 'brpServiceAddressProvince';
export const fieldBrpServiceAddressPostalCode = 'brpServiceAddressPostalCode';
export const fieldBrpOnSiteContactAccessHours = 'brpOnSiteContactAccessHours';
export const fieldBrpAlternateAppointmentDates = 'brpAlternateAppointmentDates';
export const fieldBrpTechnicianInstructions = 'brpTechnicianInstructions';
export const fieldBrpSchedulerInstruction = 'brpSchedulerInstruction';
export const fieldBrpInsideWiringRequired = 'brpInsideWiringRequired';
export const fieldBrpSupportingDocuments = 'brpSupportingDocuments';
export const fieldYesToAllAdvisories = 'yesToAllAdvisories';

export const profileKeysToList = [
  'name',
  'email',
  'role',
  'channelName',
  'dealership',
  'outlet',
  'salesRepId',
  'salesManager',
  'salesManagerEmail'
];

export const roleDescription = {
  ADMIN: 'Admin',
  SALES_REP: 'Sales Rep',
  ORDER_FULFILLMENT: 'Order Fulfillment',
  PROPOSAL_HOUSE: 'Proposal House',
  SALES_MANAGER: 'Sales Manager',
  SALES_SUPPORT: 'Sales Support'
};

export const reasonForSubmissionFrenchMappings = {
  'MSS Issue': ['MSS Defect','Problème dans le SVSM'],
  'MSS order requiring resubmission':
    'Commandes dans le SVSM qui doivent être soumises de nouveau',
  'Order is NOT eligible for MSS': 'Commande NON admissible au SVSM',
  'Expired Offer/Promo': 'Offre promotionnelle expirée',
  'LNR Webform': 'LNR Webform'
};

export const orderIsNotEligibleForMSSFrenchMappings = {
  'Number of subscribers ordered is 16+': 'Nombre d’abonnés supérieur à 16',
  'SMB Online Order': 'Commande en ligne de Solutions aux PME',
  'Order has a watch and eSim orders':
    'La commande comprend une montre et une eSim',
  'Director-approved submissions (Director approval needed in notes section)':
    'Soumissions approuvées par le directeur général (approbation requise dans la section des notes)',
  'Devices only': 'Appareils',
  'Accessories only': 'Accessoires'
};

export const WLSPendingValidationReasons = {
  MSSDefect: ['MSS Issue', 'MSS Defect', 'Problème dans le SVSM'],
  OrderIsNOTEligibleForMSS: [
    'Order is NOT eligible for MSS',
    'Commande NON admissible au SVSM'
  ],
  ExpiredOffers: ['Expired Offer/Promo', 'Offre promotionnelle expirée'],
  MSSDefectTeam: ['SMB Sales'],
  OrderIsNotEligibleForMSSReasons: [
    'Number of subscribers ordered is 16+',
    'Nombre d’abonnés supérieur à 16',
    'Director-approved submissions (Director approval needed in notes section)',
    'Soumissions approuvées par le directeur général (approbation requise dans la section des notes)',
    'Devices only',
    'Appareils'
  ],
  RequiresDirectorApproval: ['yes', 'Oui']
};

export const orderWasReturned = 'Order was returned';
export const orderIsNotEligibleForMSS = 'Order is NOT eligible for MSS';

export const WLSRestrictedChannelsForOrderCreation = [
  'BCX',
  'BCX_CARE',
  'BCX_HD' /* ,'BCX_LOYALTY' */
];

export const officePhoneExclusionChannels = [
  'SMB Growth Sales Advance 3',
  'SMB Growth Sales W 2B',
  'SMB Growth Sales W 1A',
  'SMB Growth Sales 30 to 100 2C',
  'SMB Growth Sales 30 to 100 2A',
  'SMB Growth Sales 30 to 100 2B',
  'SMB Growth Sales 30 to 100 2E',
  'SMB Retention 30 to 100 2D',
  'SMB Growth Sales W 1B',
  'SMB Growth Sales W 1C',
  'SMB Growth Sales W 1D',
  'SMB Growth Sales W 2A',
  'SMB Growth Sales W 2C',
  'SMB Growth Sales W 2D',
  'SMB New Growth Market 1',
  'SMB New Growth Market 2',
  'SMB New Growth Market 3',
  'SMB New Growth Market 4'
];

export const optikTvIncludedChannels = [
  'SMB Growth Sales W 2A',
  'SMB Growth Sales W 2B',
  'SMB Growth Sales W 2C',
  'SMB Growth Sales W 2D',
  'SMB Growth Sales W 1A',
  'SMB Growth Sales W 1B',
  'SMB Growth Sales W 1C',
  'SMB Growth Sales W 1D',
  'SMB Growth Sales 30 to 100 2A',
  'SMB Growth Sales 30 to 100 2B',
  'SMB Growth Sales 30 to 100 2C',
  'SMB New Growth Market 1',
  'SMB New Growth Market 2'
];

export const WLSRestrictedReasonForSubmissionForChannels = [
  'MSS Issue',
  'Problème dans le SVSM',
  'Order is NOT eligible for MSS',
  'Commande NON admissible au SVSM'
];

export const WLSRestrictedOrderIsNotEligibleForMSSForChannels = [
  'Number of subscribers ordered is 16+',
  'Nombre d’abonnés supérieur à 16',
  'Devices only',
  'Appareils',
  'Accessories only',
  'Accessoires'
];

export const orderReturnedOptions = {
  orderReturnRequested: 'Order return requested',
  orderWasReturned: 'Order was returned'
};

export const fieldSalesRepInfo = 'salesRepInfo';
export const fieldIsVulcanOrder = 'isVulcanOrder';
export const fieldIsVulcanOrderWLN = 'isVulcanOrderWLN';
export const fieldIsPureFibreEastLeadWLN = 'isPureFibreEastLeadWLN';
export const isVulcanLandingPage = 'Vulcan Landing Page';
export const fieldAddProductVulcan = 'addProductVulcan';
export const fieldProvinceVUL = 'province_VUL';
export const fieldWebFormOrderId = 'webFormOrderId'
export const fieldOrderIdTSB = 'orderIdTSB';
export const fieldSigningAuthorityVulcan = 'Signing Authority  ';
export const fieldServiceAddress = 'Service Address ';
export const internetBundleDiscountOption = '$10 Internet Bundle Discount';
export const internetDiscountOption = '$85 Internet 3P+ Discount';
export const billCreditOnHSIAOption = '$100 Bill Credit on HSIA';
export const internetDiscountFourtyFiveOption = '$45 Internet 3P+ Discount';
export const internetDiscountSeventyOption = '$70 Internet 3P+ Discount';
export const waivedInstallationFee = '$100 Waived Installation Fee';
export const internetBundleDiscountOptionFifteen = '$15 Internet Bundle Discount';
export const internetBundleDiscountOptionFifteenATL = '$15 Internet Bundle Discount (ATL)';
export const internetDiscountOptionEighty = '$80 Internet 3P+ Discount';
export const internetDiscountOptionFortyATL = '$40 Internet 3P+ Discount (ATL)';
export const hundredInstallationFee = '$100 Installation Fee';
export const businessWifiOption = 'Business Wifi';
export const fibreInternetOption = 'Fibre Internet';
export const tenDollarBundleDiscountOption = '$10 Bundle Discount';
export const waiveInstallationFeeOption = '$199 Waive Installation Fee';
export const fibreOfferField = 'offers';
export const errorNotePrequalificationField = 'errorNotePrequalification';
export const prequalificationSection = 'Prequalification';
export const textOnAddProduct =
  'To qualify for the Vulcan bundle, the customer must have a minimum of 3 products below (new and existing)';
export const fieldUnitType = 'unitType_VUL';
export const fieldUnitNumber = 'unitNumber_VUL';
export const fieldBusinessConnectVulcan = 'Business Connect';
export const fieldBusinessTypeVulcan = 'businessTypeVulcan';
export const fieldNumberOfAccessPoints = 'numberOfAccessPoints';
export const numberOfAccessPointsTotal = 3;
export const fieldUseInternet = 'useInternet';
export const fieldCurrentInternetProviderName = 'currentInternetProviderName';

export const resetFieldOfVulcan = [
  'streetName_VUL',
  'streetNumber_VUL',
  'province_VUL',
  'city_VUL',
  'postalCode_VUL',
  'telephoneNumberVUL',
  'reEnterEmailVUL',
  'lastNameVUL',
  'emailAddressVUL',
  'firstNameVUL'
];

export const prequalificationField = [
  'isThisBusiness',
  'isCertifiedSecuritySystem',
  'isYourBuilding',
  'isCamerasInstalled',
  'installedAtHeights',
  'customerSecuritySystem',
  'customerHaveHomeSecurity'
];

export const emailForSOW = [
  'Faruk.Abukar@telus.com',
  'gabe.abramovich@telus.com',
  'garrett.sinfield@telus.com',
  'james.szantho@telus.com',
  'Jamie.Nedelkov@telus.com',
  'Keith.Giroux@telus.com',
  'Matt.Long@telus.com',
  'patrick.chen@telus.com',
  'Phil.Colella@telus.com',
  'aneeqkhan110@gmail.com',
  'muhammad.tauqeer+sales@mobilelive.ca'
];

export const fieldSubmittingOnBehalfOf = 'submittingOnBehalfOf';
export const fieldSalesRepInfoOCDR = 'salesRepInfo';
export const fieldProductSelectionOCDR = 'productSelectionOCDR';
export const fieldContractTerm = 'contractTerm';
export const fieldDirectRouting = 'Direct Routing';
export const fieldOperatorConnect = 'Operator Connect';
export const fieldOneMonthSubscription = 'One Month Subscription';

export const ocdrContractTermOneYear = '1 year';
export const ocdrContractTermThreeYear = '3 year';
export const ocdrContractTermFiveYear = '5 year';
export const fieldMicrosoftCloudAndAdvisoryServices =
  'Microsoft Cloud and Related Services';
export const fieldExistingCustomer = 'existingCustomer';
export const fieldOrderRequestType = 'orderRequestType';
export const newBusinessAppsToTCO = 'New Business Apps to TELUS Customer Order';
export const noteNumberTelusWifiAccessPointsFibre = {
  nodeType: 'document',
  data: {},
  content: [
    {
      nodeType: 'paragraph',
      data: {},
      content: [
        {
          nodeType: 'text',
          value: `Note: Must select at least 1 Wi-Fi Access Point `,
          marks: [
            {
              type: 'bold'
            }
          ],
          data: {}
        },
        {
          nodeType: 'text',
          value:
            'and up to 3 add up to 3 Wi-Fi Access Points; $75 installation fee to be waived',
          marks: [],
          data: {}
        }
      ]
    }
  ]
};

export const promosForAB = {
  '1.5G/940 mbps': 'limitedTimeOfferYearly15gAlbertaBC',
  '940/940 mbps': 'limitedYearlyOffersFibreAlbertaBC',
  '3G/3000 mbps': 'limitedTimeOfferYearly3g_3000AlbertaBC'
};

export const channelNameForLNR = [
  'SMB L&R 2',
  'SMB L&R 3',
  'SMB L&R 4',
  'SMB L&R 5',
  'SMB L&R TI',
  'SMB L&R TI 2',
  'SMB L&R TI 3'
];

export const outletIdLNR = [
  '1100052642',
  '1100052643',
  '1100052644',
  '1100052645',
  '1100052647',
  '1100052977',
  '1100053942'
];

export const valueLNRWebform = 'LNR Webform';

export const listChannelForTSB = [
  'SMB L&R 1',
  'SMB L&R 2',
  'SMB L&R 3',
  'SMB L&R 4',
  'SMB L&R 5',
  'SMB L&R TI',
  'SMB L&R TI 2',
  'SMB L&R TI 3',
  'SMB Retention 1 to 30 1A',
  'SMB Retention 1 to 30 1B',
  'SMB Retention 1 to 30 1C',
  'SMB Retention 1 to 30 1D',
  'SMB Retention 30 to 100 2A',
  'SMB Retention 30 to 100 2B',
  'SMB Retention 30 to 100 2C',
  'SMB Retention 30 to 100 2D',
  'SMB Retention Sales 30 to 100 2D',
  'BCX',
  'BCX - HD',
  'BCX - LOYALTY',
  'BCX Care',
  'DEALER'
];

export const valuePublic = 'Public';
export const valuePrivate = 'Private';

export const thirtySixMonthsValue = '36 Months';
export const thirtySixMonthsValueFR = 'Entente de 36 mois';

export const twelveMonthPromoOptik = '12 Month promo optik';
export const sixMonthPromoOptik = '6 Month promo optik';

export const creditCheckNumberField = 'creditCheckNumber';
export const fieldTechnicalReviewNumber = 'technicalReviewNumber';
export const categoryGroup = [
  {
    categoryGroupTitle: "Wireline | Secure Business | Wireless",
    categoryGroupItems: [
      "wireline and secure business",
      "wireless"
    ]
  },
  {
    categoryGroupTitle: "Business Connect",
    categoryGroupItems: [
      "TELUS Business Connect Quote Tool/Order Form",
      "Phone Number Portal Tool",
      "TELUS Business Connect Contact Centre & Professional Services"
    ]
  },
  {
    categoryGroupTitle: "Internet of Things | Business Apps",
    categoryGroupItems: [
      "TELUS Business Apps",
      "TELUS IOT"
    ]
  },
  {
    categoryGroupTitle: "Fully Managed",
    categoryGroupItems: [
      "fully managed",
      "fully managed SOW"
    ]
  },
  {
    categoryGroupTitle: "Other",
    categoryGroupItems: [
      "brp webform",
      "referrals",
      "My Order Dashboard",
      "vulcan",
      "OCDR"
    ]
  },
  {
    categoryGroupTitle: "Emergency Webforms",
    categoryGroupItems: []
  }
];

export const preferredLanguageVulcanVariable = {
  'en-US':['English','Anglais'],
  'fr-CA':['French','Français']
};

export const isCouponBasedDiscountField = 'isCouponBasedDiscount';

export const ignoredKeysOfSelectedItems = [
  'businessActivityAnalytics',
  'temperatureMonitoringFiveDollar',
  'temperatureMonitoringTenDollar',
  'temperatureMonitoringFiveDollarVulcan',
  'temperatureMonitoringTenDollarVulcan'
];
export const ALL_USERS = 'All users';
export const INTERNAL_USERS = 'Internal users only';
export const EXTERNAL_USERS = 'External users only';

export const tcvDmTermThreshold = {
  '12 months': 30,
  '24 Months': 34,
  '36 Months': 32
};

export const hideFormCategories = ['OCDR', 'cybersecurity'];

export const showFormForEmail = [
  'muhammad.tauqeer@mobilelive.ca',
  'muhammad.tauqeer+sales@mobilelive.ca',
  'aneeq.khan@mobilelive.ca',
  'shoubo.ali@telus.com'
];
